import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { InlineAlert, SearchModal, RowItem, InfoState, Button, ButtonSize, IconCatalog, ButtonVariant, EmptyState, ErrorState, TagV2, TagV2Appearance, TagV2Type, TagV2Size, SimpleTooltip, TooltipPosition, Icon, Tag, TagVariant, useDebounce, Typeahead, FormFieldState, PhoneInput, Switch, TextInput, SelectV2, Checkbox, InlineAlertVariant, useModal, BaseModal, ModalSize } from '@eva-tech/eva-eden';
import { gql, useApolloClient, useLazyQuery, useMutation, useQuery, ApolloProvider } from '@apollo/client';
import React, { useState, useRef, useEffect, useMemo } from 'react';
import cn from 'classnames';
import { useFormContext, useForm, FormProvider, get as get$1, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$h =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || commonjsGlobal || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$i = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$h = fails$i;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$h(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var fails$g = fails$i;

var functionBindNative = !fails$g(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$1 = functionBindNative;

var call$9 = Function.prototype.call;

var functionCall = NATIVE_BIND$1 ? call$9.bind(call$9) : function () {
  return call$9.apply(call$9, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND = functionBindNative;

var FunctionPrototype$1 = Function.prototype;
var call$8 = FunctionPrototype$1.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype$1.bind.bind(call$8, call$8);

var functionUncurryThis = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$8.apply(fn, arguments);
  };
};

var uncurryThis$g = functionUncurryThis;

var toString$7 = uncurryThis$g({}.toString);
var stringSlice$3 = uncurryThis$g(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$3(toString$7(it), 8, -1);
};

var uncurryThis$f = functionUncurryThis;
var fails$f = fails$i;
var classof$5 = classofRaw$2;

var $Object$4 = Object;
var split = uncurryThis$f(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$f(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$5(it) === 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$3 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$2 = isNullOrUndefined$3;

var $TypeError$9 = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$5 = function (it) {
  if (isNullOrUndefined$2(it)) throw new $TypeError$9("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$4 = requireObjectCoercible$5;

var toIndexedObject$5 = function (it) {
  return IndexedObject$2(requireObjectCoercible$4(it));
};

var documentAll$2 = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;

var documentAll_1 = {
  all: documentAll$2,
  IS_HTMLDDA: IS_HTMLDDA
};

var $documentAll$1 = documentAll_1;

var documentAll$1 = $documentAll$1.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$h = $documentAll$1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$g = isCallable$h;
var $documentAll = documentAll_1;

var documentAll = $documentAll.all;

var isObject$7 = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable$g(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable$g(it);
};

var global$g = global$h;
var isCallable$f = isCallable$h;

var aFunction = function (argument) {
  return isCallable$f(argument) ? argument : undefined;
};

var getBuiltIn$3 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$g[namespace]) : global$g[namespace] && global$g[namespace][method];
};

var uncurryThis$e = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$e({}.isPrototypeOf);

var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

var global$f = global$h;
var userAgent = engineUserAgent;

var process = global$f.process;
var Deno = global$f.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = engineV8Version;
var fails$e = fails$i;
var global$e = global$h;

var $String$5 = global$e.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$e(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$2 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$2 = getBuiltIn$3;
var isCallable$e = isCallable$h;
var isPrototypeOf$1 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$2('Symbol');
  return isCallable$e($Symbol) && isPrototypeOf$1($Symbol.prototype, $Object$3(it));
};

var $String$4 = String;

var tryToString$1 = function (argument) {
  try {
    return $String$4(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$d = isCallable$h;
var tryToString = tryToString$1;

var $TypeError$8 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$3 = function (argument) {
  if (isCallable$d(argument)) return argument;
  throw new $TypeError$8(tryToString(argument) + ' is not a function');
};

var aCallable$2 = aCallable$3;
var isNullOrUndefined$1 = isNullOrUndefined$3;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$2 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$1(func) ? undefined : aCallable$2(func);
};

var call$7 = functionCall;
var isCallable$c = isCallable$h;
var isObject$6 = isObject$7;

var $TypeError$7 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$c(fn = input.toString) && !isObject$6(val = call$7(fn, input))) return val;
  if (isCallable$c(fn = input.valueOf) && !isObject$6(val = call$7(fn, input))) return val;
  if (pref !== 'string' && isCallable$c(fn = input.toString) && !isObject$6(val = call$7(fn, input))) return val;
  throw new $TypeError$7("Can't convert object to primitive value");
};

var shared$4 = {exports: {}};

var global$d = global$h;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$6(global$d, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$d[key] = value;
  } return value;
};

var global$c = global$h;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$c[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$4.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.33.1',
  mode: 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.33.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible$3 = requireObjectCoercible$5;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$4 = function (argument) {
  return $Object$2(requireObjectCoercible$3(argument));
};

var uncurryThis$d = functionUncurryThis;
var toObject$3 = toObject$4;

var hasOwnProperty = uncurryThis$d({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$3(it), key);
};

var uncurryThis$c = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$6 = uncurryThis$c(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$6(++id + postfix, 36);
};

var global$b = global$h;
var shared$3 = shared$4.exports;
var hasOwn$9 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$1 = global$b.Symbol;
var WellKnownSymbolsStore = shared$3('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$b = function (name) {
  if (!hasOwn$9(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL$1 && hasOwn$9(Symbol$1, name)
      ? Symbol$1[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$6 = functionCall;
var isObject$5 = isObject$7;
var isSymbol$1 = isSymbol$2;
var getMethod$1 = getMethod$2;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$a = wellKnownSymbol$b;

var $TypeError$6 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$a('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$5(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$1(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$6(exoticToPrim, input, pref);
    if (!isObject$5(result) || isSymbol$1(result)) return result;
    throw new $TypeError$6("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$a = global$h;
var isObject$4 = isObject$7;

var document$1 = global$a.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$4(document$1) && isObject$4(document$1.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$a = descriptors;
var fails$d = fails$i;
var createElement = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$a && !fails$d(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

var DESCRIPTORS$9 = descriptors;
var call$5 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$8 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$9 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$8(O, P)) return createPropertyDescriptor$2(!call$5(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$8 = descriptors;
var fails$c = fails$i;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$8 && fails$c(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var isObject$3 = isObject$7;

var $String$3 = String;
var $TypeError$5 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$8 = function (argument) {
  if (isObject$3(argument)) return argument;
  throw new $TypeError$5($String$3(argument) + ' is not an object');
};

var DESCRIPTORS$7 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$7 = anObject$8;
var toPropertyKey = toPropertyKey$2;

var $TypeError$4 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$7 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$7(O);
  P = toPropertyKey(P);
  anObject$7(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$7(O);
  P = toPropertyKey(P);
  anObject$7(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$4('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$6 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;

var createNonEnumerableProperty$5 = DESCRIPTORS$6 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$5 = descriptors;
var hasOwn$7 = hasOwnProperty_1;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$5 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$7(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$5 || (DESCRIPTORS$5 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$b = functionUncurryThis;
var isCallable$b = isCallable$h;
var store$1 = sharedStore;

var functionToString = uncurryThis$b(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$b(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$1 = store$1.inspectSource;

var global$9 = global$h;
var isCallable$a = isCallable$h;

var WeakMap$1 = global$9.WeakMap;

var weakMapBasicDetection = isCallable$a(WeakMap$1) && /native code/.test(String(WeakMap$1));

var shared$2 = shared$4.exports;
var uid = uid$2;

var keys = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$8 = global$h;
var isObject$2 = isObject$7;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$5;
var hasOwn$6 = hasOwnProperty_1;
var shared$1 = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = global$8.TypeError;
var WeakMap = global$8.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$2(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$6(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$4(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$6(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$6(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var uncurryThis$a = functionUncurryThis;
var fails$b = fails$i;
var isCallable$9 = isCallable$h;
var hasOwn$5 = hasOwnProperty_1;
var DESCRIPTORS$4 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource = inspectSource$1;
var InternalStateModule$1 = internalState;

var enforceInternalState = InternalStateModule$1.enforce;
var getInternalState$2 = InternalStateModule$1.get;
var $String$2 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;
var stringSlice$2 = uncurryThis$a(''.slice);
var replace$3 = uncurryThis$a(''.replace);
var join = uncurryThis$a([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$4 && !fails$b(function () {
  return defineProperty$5(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice$2($String$2(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$3($String$2(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$5(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$4) defineProperty$5(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$5(options, 'arity') && value.length !== options.arity) {
    defineProperty$5(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$5(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$4) defineProperty$5(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$5(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$9(this) && getInternalState$2(this).source || inspectSource(this);
}, 'toString');

var isCallable$8 = isCallable$h;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltIn$3.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$4 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$8(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$2.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity = toIntegerOrInfinity$2;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$2 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$1 = lengthOfArrayLike$2;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike$1(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var uncurryThis$9 = functionUncurryThis;
var hasOwn$4 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push = uncurryThis$9([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$4(hiddenKeys$2, key) && hasOwn$4(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$4(O, key = names[i++])) {
    ~indexOf$1(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$1 = getBuiltIn$3;
var uncurryThis$8 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$6 = anObject$8;

var concat$1 = uncurryThis$8([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$1('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$6(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$3 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$1.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$3(target, key) && !(exceptions && hasOwn$3(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$a = fails$i;
var isCallable$7 = isCallable$h;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable$7(detection) ? fails$a(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$7 = global$h;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$5;
var defineBuiltIn$3 = defineBuiltIn$4;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$7;
  } else if (STATIC) {
    target = global$7[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$7[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$3(sourceProperty, 'sham', true);
    }
    defineBuiltIn$3(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$3 = descriptors;
var uncurryThis$7 = functionUncurryThis;
var call$4 = functionCall;
var fails$9 = fails$i;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$2 = toObject$4;
var IndexedObject$1 = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$4 = Object.defineProperty;
var concat = uncurryThis$7([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$9(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$3 && $assign({ b: 1 }, $assign(defineProperty$4({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$4(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys$1($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$2(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$3 || call$4(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$7 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$7({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

var objectDefineProperties = {};

var DESCRIPTORS$2 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$5 = anObject$8;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$2 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$5(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn = getBuiltIn$3;

var html$1 = getBuiltIn('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */
var anObject$4 = anObject$8;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$4(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$9 = wellKnownSymbol$b;
var create$2 = objectCreate;
var defineProperty$3 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$9('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty$3(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$2(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$8 = fails$i;

var correctPrototypeGetter = !fails$8(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$2 = hasOwnProperty_1;
var isCallable$6 = isCallable$h;
var toObject$1 = toObject$4;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject$1(O);
  if (hasOwn$2(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$6(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$1 ? ObjectPrototype : null;
};

var fails$7 = fails$i;
var isCallable$5 = isCallable$h;
var isObject$1 = isObject$7;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$2 = defineBuiltIn$4;
var wellKnownSymbol$8 = wellKnownSymbol$b;

var ITERATOR$2 = wellKnownSymbol$8('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$1(IteratorPrototype$2) || fails$7(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$2].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$5(IteratorPrototype$2[ITERATOR$2])) {
  defineBuiltIn$2(IteratorPrototype$2, ITERATOR$2, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$2 = objectDefineProperty.f;
var hasOwn$1 = hasOwnProperty_1;
var wellKnownSymbol$7 = wellKnownSymbol$b;

var TO_STRING_TAG$3 = wellKnownSymbol$7('toStringTag');

var setToStringTag$2 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$1(target, TO_STRING_TAG$3)) {
    defineProperty$2(target, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$1 = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$1 = setToStringTag$2;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$1(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var uncurryThis$6 = functionUncurryThis;
var aCallable$1 = aCallable$3;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$6(aCallable$1(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isCallable$4 = isCallable$h;

var $String$1 = String;
var $TypeError$3 = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$4(argument)) return argument;
  throw new $TypeError$3("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = functionUncurryThisAccessor;
var anObject$3 = anObject$8;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$3(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$6 = _export;
var call$3 = functionCall;
var FunctionName = functionName;
var isCallable$3 = isCallable$h;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$2;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$5;
var defineBuiltIn$1 = defineBuiltIn$4;
var wellKnownSymbol$6 = wellKnownSymbol$b;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$1 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol$6('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$3(CurrentIteratorPrototype[ITERATOR$1])) {
          defineBuiltIn$1(CurrentIteratorPrototype, ITERATOR$1, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$1 && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$2(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$3(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$1(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$6({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$1] !== defaultIterator) {
    defineBuiltIn$1(IterablePrototype, ITERATOR$1, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$1 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$1 = addToUnscopables$2;
var Iterators = iterators;
var InternalStateModule = internalState;
var defineProperty$1 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject = createIterResultObject$1;
var DESCRIPTORS$1 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState$1 = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$1 && values.name !== 'values') try {
  defineProperty$1(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$6 = global$h;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$5;
var wellKnownSymbol$5 = wellKnownSymbol$b;

var ITERATOR = wellKnownSymbol$5('iterator');
var TO_STRING_TAG$2 = wellKnownSymbol$5('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty$1(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$2]) {
      createNonEnumerableProperty$1(CollectionPrototype, TO_STRING_TAG$2, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$6[COLLECTION_NAME] && global$6[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

var aCallable = aCallable$3;
var toObject = toObject$4;
var IndexedObject = indexedObject;
var lengthOfArrayLike = lengthOfArrayLike$2;

var $TypeError$2 = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$1 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw new $TypeError$2('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$1(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$1(true)
};

var fails$6 = fails$i;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$6(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var global$5 = global$h;
var classof$4 = classofRaw$2;

var engineIsNode = classof$4(global$5.process) === 'process';

var $$5 = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var CHROME_VERSION = engineV8Version;
var IS_NODE = engineIsNode;

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$5({ target: 'Array', proto: true, forced: FORCED }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

const practitionerTranslations = searchTerm => ({
  en: {
    tel: 'Tel',
    name: 'Name',
    phone: 'Phone',
    goBack: 'Go back',
    email: 'Email',
    refDoctorFirstName: `Doctor's first surname`,
    refDoctorSecondSurname: `Doctor's second surname`,
    disclaimerRequiredFields: 'Fields marked with an asterisk an * are required',
    doctorLicense: 'Referring doctor professional license',
    inviteRefDoctor: 'Invite referring doctor to create account in PACS',
    singleSelectionPlaceholder: 'Select an option',
    refDoctorName: 'Referring doctor name',
    refDoctorEmail: 'Referring doctor email',
    firstSurname: 'First surname',
    secondSurname: 'Second surname',
    confirm: 'Confirm',
    noData: 'No data',
    specialty: 'Specialty',
    proLicense: 'Professional license',
    modalTitle: 'Assign Referring Doctor',
    suspendedPractitioner: 'This referring doctor is suspended and does not have access to PACS.',
    searchBarPlaceholder: 'Referring practitioners search',
    emtpyStateTitle: 'There are no referring practitioners registered on our systems.',
    emptyStateDescription: 'Currently, no referring doctor has been registered in the system.',
    emptyStateButtonText: 'Create referring practitioner',
    errorStateTitle: 'Loading error',
    errorStateBody: `There was an error trying to load the referring practitioner's list. Try again.`,
    errorStateButtonText: 'Update',
    searchEmptyStateTitle: 'No results found for this search',
    searchEmptyStateDescription: `No results found for "${searchTerm}".`,
    searchEmptyStateButtonText: `Create referring practitioner "${searchTerm}"`,
    modalityPractitionerDescription: `Referring physician's modality`,
    confirmConcernModalTitle: `Confirm "To whom it may concern"`,
    confirmPractitioner: 'Confirm referring practitioner',
    toWhomItMayConcern: 'To whom it may concern',
    withoutContactInformation: 'Without contact information',
    editInformationLater: `You will be able to edit the information of the referring doctor after confirming your selection`,
    toWhomItMayConcernDisclaimer: 'Select this value to assign "To whom it may concern"',
    wrongPhoneFormat: 'The phone format is invalid.',
    wrongEmailFormat: 'The email format is invalid.',
    requiredField: 'This field is required',
    confirmWhomConcernQuestion: 'Are you sure you want to mark this field as "To Whom It May Concern"?',
    incorrectDataQuestion: 'Is there any incorrect information?'
  },
  es: {
    tel: 'Tel',
    name: 'Nombre',
    phone: 'Teléfono',
    goBack: 'Regresar',
    email: 'Correo electrónico',
    refDoctorFirstName: `Primer apellido del médico referente`,
    refDoctorSecondSurname: `Segundo apellido del médico referente`,
    disclaimerRequiredFields: 'Los campos marcados con asterisco * son obligatorios',
    doctorLicense: 'Cédula del o la médico referente',
    inviteRefDoctor: 'Invitar a crear cuenta en el Portal de Médicos Referentes',
    singleSelectionPlaceholder: 'Elige una opción',
    refDoctorName: 'Nombre del médico referente',
    refDoctorEmail: 'Correo del médico referente',
    firstSurname: 'Primer apellido',
    secondSurname: 'Segundo apellido',
    confirm: 'Confirmar',
    noData: 'Sin información',
    specialty: 'Especialidad',
    proLicense: 'Cédula profesional',
    suspendedPractitioner: 'Este médico referente está suspendido y no tiene acceso a PACS.',
    modalTitle: 'Asignar Médico Referente',
    searchBarPlaceholder: 'Búsqueda de médicos referentes',
    emtpyStateTitle: 'No hay medicos referentes registrados.',
    emptyStateDescription: 'Actualmente, no se ha registrado ningún médico referente en el sistema.',
    emptyStateButtonText: 'Crear médico referente',
    errorStateTitle: 'Error de carga',
    errorStateBody: `Ocurrió un error al intentar cargar el listado de médicos referentes. Intenta de nuevo.`,
    errorStateButtonText: 'Actualizar',
    searchEmptyStateTitle: 'No se encontraron resultados para esta búsqueda',
    searchEmptyStateDescription: `No se encontraron resultados para "${searchTerm}".`,
    searchEmptyStateButtonText: `Crear médico referente "${searchTerm}"`,
    modalityPractitionerDescription: `Médico referente de la modalidad`,
    confirmConcernModalTitle: `Confirmar "A quien corresponda"`,
    confirmPractitioner: 'Confirmar médico referente',
    toWhomItMayConcern: 'A quien corresponda',
    withoutContactInformation: 'Sin información de contacto',
    editInformationLater: `Podrás editar los datos del médico referente después de confirmar tu selección`,
    toWhomItMayConcernDisclaimer: 'Selecciona este valor para asignar "A quien corresponda"',
    wrongPhoneFormat: 'El formato del teléfono es inválido.',
    wrongEmailFormat: 'El formato del correo es inválido.',
    requiredField: 'Este campo es requerido',
    confirmWhomConcernQuestion: '¿Estás seguro de que deseas marcar este campo como "A quien corresponda"?',
    incorrectDataQuestion: '¿Hay algún dato incorrecto?'
  },
  pt: {
    tel: 'Tel',
    name: 'Nome',
    phone: 'Telefone',
    goBack: 'Volte',
    email: 'Correio eletrônico',
    refDoctorFirstName: `Primeiro sobrenome do médico solicitante`,
    refDoctorSecondSurname: `Segundo sobrenome do médico solicitante`,
    disclaimerRequiredFields: 'Os campos marcados com asterisco * são obrigatórios',
    doctorLicense: 'Registro do médico referente',
    inviteRefDoctor: 'Convidar para criar uma conta no Portal dos Médicos de Referência',
    singleSelectionPlaceholder: 'Escolha uma opção',
    refDoctorName: 'Nome do médico referente',
    refDoctorEmail: 'E-mail do médico referente',
    firstSurname: 'Primeiro apelido',
    secondSurname: 'Segundo sobrenome',
    confirm: 'Confirme',
    noData: 'Sem informações',
    specialty: 'Especialidade',
    proLicense: 'Registro profissional',
    suspendedPractitioner: 'Este médico encaminhador está suspenso e não tem acesso ao PACS.',
    modalTitle: 'Atribuir Médico de Referência',
    searchBarPlaceholder: 'Procure por médicos referenciadores',
    emtpyStateTitle: 'Não há médicos referenciadores cadastrados.',
    emptyStateDescription: 'Atualmente, nenhum médico referente está cadastrado no sistema.',
    emptyStateButtonText: 'Criar médico de referência',
    errorStateTitle: 'Erro de carregamento',
    errorStateBody: 'Ocorreu um erro ao tentar carregar a lista de médicos solicitantes. Tenta de novo.',
    errorStateButtonText: 'Atualizar',
    searchEmptyStateTitle: 'Nenhum resultado encontrado para esta pesquisa',
    searchEmptyStateDescription: `Nenhum resultado encontrado para "${searchTerm}".`,
    searchEmptyStateButtonText: `Criar médico de referência "${searchTerm}"`,
    modalityPractitionerDescription: `Médico referenciador para a modalidade`,
    confirmConcernModalTitle: `Confirme "A quem possa interessar"`,
    confirmPractitioner: 'Confirme o médico que encaminhou',
    toWhomItMayConcern: 'A quem possa interessar',
    withoutContactInformation: 'Nenhuma informação de contato',
    editInformationLater: `Você poderá editar as informações do médico solicitante após confirmar sua seleção`,
    toWhomItMayConcernDisclaimer: 'Seleciona este valor para atribuir "A quem possa interessar"',
    wrongPhoneFormat: 'O formato do telefone é inválido.',
    wrongEmailFormat: 'O formato do e-mail é inválido.',
    requiredField: 'Este campo é obrigatório',
    confirmWhomConcernQuestion: 'Tem certeza de que deseja marcar este campo como "A quem possa interessar"?',
    incorrectDataQuestion: 'Existe alguma informação incorreta?'
  }
});

/**
 * Hook to get the translations for the practitioner module.
 * @param locale The locale to get the translations for.
 * @author Salvador Gonzalez<salvador.gonzalez@edenmed.com>
 * @returns The translations for the practitioner module.
 */

const usePractitionerTranslations = locale => {
  const [translations, setTranslations] = useState(practitionerTranslations('')[locale]);

  const getTranslations = searchText => {
    const localTranslations = practitionerTranslations(searchText)[locale];
    setTranslations(localTranslations);
  };

  return {
    translations,
    getTranslations
  };
};

const AssignationModal = ({
  practitioner,
  toWhomItMayConcern,
  locale
}) => {
  const {
    translations
  } = usePractitionerTranslations(locale);
  const classes = {
    itemClass: cn('e-my-3'),
    itemTitle: cn('e-text-xs e-text-neutral-300 e-mb-1'),
    itemDescription: cn('e-text-sm e-text-neutral-200')
  };
  if (toWhomItMayConcern) return jsx("p", Object.assign({
    className: "e-text-base e-text-neutral-50"
  }, {
    children: translations.confirmWhomConcernQuestion
  }));

  const renderItemText = itemText => {
    if (!itemText) return jsx("p", Object.assign({
      className: "e-text-sm e-text-neutral-500"
    }, {
      children: translations.noData
    }));
    return jsx("p", Object.assign({
      className: classes.itemDescription
    }, {
      children: itemText
    }));
  };

  return jsxs("div", Object.assign({
    className: "e-min-w-full"
  }, {
    children: [jsx(InlineAlert, {
      title: translations.incorrectDataQuestion,
      description: translations.editInformationLater
    }), jsx("section", {
      children: jsxs("div", Object.assign({
        className: "e-grid e-grid-cols-3"
      }, {
        children: [jsxs("div", Object.assign({
          className: classes.itemClass
        }, {
          children: [jsx("p", Object.assign({
            className: classes.itemTitle
          }, {
            children: translations.name
          })), jsx("p", Object.assign({
            className: classes.itemDescription
          }, {
            children: renderItemText(practitioner.name)
          }))]
        })), jsxs("div", Object.assign({
          className: classes.itemClass
        }, {
          children: [jsx("p", Object.assign({
            className: classes.itemTitle
          }, {
            children: translations.firstSurname
          })), jsx("p", Object.assign({
            className: classes.itemDescription
          }, {
            children: renderItemText(practitioner.firstSurname)
          }))]
        })), jsxs("div", Object.assign({
          className: classes.itemClass
        }, {
          children: [jsx("p", Object.assign({
            className: classes.itemTitle
          }, {
            children: translations.secondSurname
          })), jsx("p", Object.assign({
            className: classes.itemDescription
          }, {
            children: renderItemText(practitioner.lastSurname)
          }))]
        })), jsxs("div", Object.assign({
          className: classes.itemClass
        }, {
          children: [jsx("p", Object.assign({
            className: classes.itemTitle
          }, {
            children: translations.email
          })), jsx("p", Object.assign({
            className: classes.itemDescription
          }, {
            children: renderItemText(practitioner.email)
          }))]
        })), jsxs("div", Object.assign({
          className: `e-col-span-2 ${classes.itemClass}`
        }, {
          children: [jsx("p", Object.assign({
            className: classes.itemTitle
          }, {
            children: translations.phone
          })), jsx("p", Object.assign({
            className: classes.itemDescription
          }, {
            children: renderItemText(practitioner.phone.phone)
          }))]
        })), jsxs("div", Object.assign({
          className: classes.itemClass
        }, {
          children: [jsx("p", Object.assign({
            className: classes.itemTitle
          }, {
            children: translations.specialty
          })), jsx("p", Object.assign({
            className: classes.itemDescription
          }, {
            children: renderItemText(practitioner.specialty.name)
          }))]
        })), jsxs("div", Object.assign({
          className: classes.itemClass
        }, {
          children: [jsx("p", Object.assign({
            className: classes.itemTitle
          }, {
            children: translations.proLicense
          })), jsx("p", Object.assign({
            className: classes.itemDescription
          }, {
            children: renderItemText(practitioner.licenseNumber)
          }))]
        }))]
      }))
    })]
  }));
};

var wellKnownSymbol$4 = wellKnownSymbol$b;

var TO_STRING_TAG$1 = wellKnownSymbol$4('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$2 = isCallable$h;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$3 = wellKnownSymbol$b;

var TO_STRING_TAG = wellKnownSymbol$3('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$3 = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) === 'Object' && isCallable$2(O.callee) ? 'Arguments' : result;
};

var classof$2 = classof$3;

var $String = String;

var toString$5 = function (argument) {
  if (classof$2(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

var anObject$2 = anObject$8;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$2(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var fails$5 = fails$i;
var global$4 = global$h;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$4.RegExp;

var UNSUPPORTED_Y$1 = fails$5(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$1 || fails$5(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$1 || fails$5(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$1
};

var fails$4 = fails$i;
var global$3 = global$h;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$3.RegExp;

var regexpUnsupportedDotAll = fails$4(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});

var fails$3 = fails$i;
var global$2 = global$h;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$2.RegExp;

var regexpUnsupportedNcg = fails$3(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$2 = functionCall;
var uncurryThis$5 = functionUncurryThis;
var toString$4 = toString$5;
var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var shared = shared$4.exports;
var create = objectCreate;
var getInternalState = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis$5(''.charAt);
var indexOf = uncurryThis$5(''.indexOf);
var replace$2 = uncurryThis$5(''.replace);
var stringSlice$1 = uncurryThis$5(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$2(nativeExec, re1, 'a');
  call$2(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString$4(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$2(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call$2(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$2(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$1(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$2(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$1(match.input, charsAdded);
        match[0] = stringSlice$1(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$2(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$4 = _export;
var exec = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$4({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});

var classofRaw = classofRaw$2;
var uncurryThis$4 = functionUncurryThis;

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$4(fn);
};

// TODO: Remove from `core-js@4` since it's moved to entry points

var uncurryThis$3 = functionUncurryThisClause;
var defineBuiltIn = defineBuiltIn$4;
var regexpExec$1 = regexpExec$2;
var fails$2 = fails$i;
var wellKnownSymbol$2 = wellKnownSymbol$b;
var createNonEnumerableProperty = createNonEnumerableProperty$5;

var SPECIES = wellKnownSymbol$2('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$2(KEY);

  var DELEGATES_TO_SYMBOL = !fails$2(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$2(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis$3(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis$3(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};

var call$1 = functionCall;
var anObject$1 = anObject$8;
var isCallable$1 = isCallable$h;
var classof$1 = classofRaw$2;
var regexpExec = regexpExec$2;

var $TypeError$1 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$1(exec)) {
    var result = call$1(exec, R, S);
    if (result !== null) anObject$1(result);
    return result;
  }
  if (classof$1(R) === 'RegExp') return call$1(regexpExec, R, S);
  throw new $TypeError$1('RegExp#exec called on incompatible receiver');
};

var call = functionCall;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject = anObject$8;
var isNullOrUndefined = isNullOrUndefined$3;
var requireObjectCoercible$2 = requireObjectCoercible$5;
var sameValue = sameValue$1;
var toString$3 = toString$5;
var getMethod = getMethod$2;
var regExpExec = regexpExecAbstract;

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible$2(this);
      var searcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, SEARCH);
      return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString$3(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString$3(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

var makeBuiltIn = makeBuiltIn$3.exports;
var defineProperty = objectDefineProperty;

var defineBuiltInAccessor$1 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};

var $$3 = _export;
var DESCRIPTORS = descriptors;
var global$1 = global$h;
var uncurryThis$2 = functionUncurryThis;
var hasOwn = hasOwnProperty_1;
var isCallable = isCallable$h;
var isPrototypeOf = objectIsPrototypeOf;
var toString$2 = toString$5;
var defineBuiltInAccessor = defineBuiltInAccessor$1;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$1.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString$2(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = uncurryThis$2(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis$2(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace$1 = uncurryThis$2(''.replace);
  var stringSlice = uncurryThis$2(''.slice);

  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace$1(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$3({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

var SearchModalState;

(function (SearchModalState) {
  SearchModalState["SEARCH_EMPTY_STATE"] = "search_empty_state";
  SearchModalState["EMPTY_STATE"] = "empty_state";
  SearchModalState["ERROR_STATE"] = "error_state";
  SearchModalState["SUCCESSFULL_STATE"] = "successfull_state";
})(SearchModalState || (SearchModalState = {}));

const CustomSearchModal = ({
  isFetchingMore,
  rowsData: _rowsData = [],
  footer,
  hasMoreResults,
  alertMsg,
  showSkeletons: _showSkeletons = true,
  errorStateProps,
  emptyStateProps,
  searchEmptyStateProps,
  onItemClick,
  onSearchChange,
  onLoadMore,
  onClose,
  onCleanClick,
  modalTitle,
  showAlertMsg,
  searchText: _searchText = '',
  searchBarPlaceholder,
  hasError,
  className
}) => {
  const {
    emptyStateDescription,
    emptyStateTitle,
    emptyStateButtonText,
    emptyStateButtonClick
  } = emptyStateProps;
  const {
    errorStateBody,
    errorStateButtonText,
    errorStateTitle,
    errorStateButtonClick
  } = errorStateProps;
  const {
    buttonText: searchEmptyStateButtonText,
    searchStateButtonClick
  } = searchEmptyStateProps;
  const searchRef = useRef();

  const getClassesPerRow = isSelected => ({
    rowItemContainer: cn('e-flex e-items-start e-flex-col e-flex-1'),
    rowItemText: cn('e-text-sm e-text-neutral-50', {
      'e-mb-2': !isSelected,
      'e-mb-1': isSelected
    }),
    rowItemSubtext: cn('e-text-xs e-text-neutral-300')
  });

  const handleCloseModal = () => {
    if (onClose) onClose();
  };

  const currentModalState = getCurrentModalState({
    hasError,
    isFetchingMore,
    rowsData: _rowsData,
    searchText: _searchText,
    showSkeletons: _showSkeletons
  });

  const handleModalBody = () => {
    switch (currentModalState) {
      case SearchModalState.ERROR_STATE:
        {
          searchRef.current.focus();
          return jsx("div", Object.assign({
            className: "e-flex e-h-full e-items-center e-justify-center e-w-full"
          }, {
            children: jsx(ErrorState, {
              body: errorStateBody,
              hasBorder: false,
              title: errorStateTitle,
              actions: errorStateButtonText && jsx(Button, Object.assign({
                isLoading: isFetchingMore,
                size: ButtonSize.xs,
                variant: ButtonVariant.tertiaryNeutral,
                onClick: errorStateButtonClick
              }, {
                children: errorStateButtonText
              }))
            })
          }));
        }

      case SearchModalState.SEARCH_EMPTY_STATE:
        return jsx("div", Object.assign({
          className: "e-flex e-h-full e-items-center e-justify-center e-w-full"
        }, {
          children: jsx(EmptyState, {
            hasBorder: false,
            iconSize: 32,
            title: searchEmptyStateProps.title,
            icon: IconCatalog.search,
            description: searchEmptyStateProps.description,
            actions: searchEmptyStateButtonText && jsx(Button, Object.assign({
              size: ButtonSize.xs,
              endIcon: IconCatalog.plus,
              variant: ButtonVariant.primary,
              onClick: searchStateButtonClick
            }, {
              children: searchEmptyStateButtonText
            }))
          })
        }));

      case SearchModalState.EMPTY_STATE:
        return jsx("div", Object.assign({
          className: "e-flex e-h-full e-items-center e-justify-center e-w-full"
        }, {
          children: jsx(InfoState, {
            hasBorder: false,
            title: emptyStateTitle,
            description: emptyStateDescription,
            actions: emptyStateButtonText && jsx(Button, Object.assign({
              size: ButtonSize.xs,
              endIcon: IconCatalog.plus,
              variant: ButtonVariant.primary,
              onClick: emptyStateButtonClick
            }, {
              children: emptyStateButtonText
            }))
          })
        }));

      default:
        return _rowsData.map((dataItem, index) => {
          const classes = getClassesPerRow(dataItem.isSelected);
          return jsx(RowItem, Object.assign({
            isSelected: dataItem.isSelected,
            itemId: dataItem.itemId
          }, {
            children: jsxs("div", Object.assign({
              className: classes.rowItemContainer
            }, {
              children: [jsx("div", Object.assign({
                className: classes.rowItemText
              }, {
                children: dataItem === null || dataItem === void 0 ? void 0 : dataItem.item
              })), jsx("div", Object.assign({
                className: classes.rowItemSubtext
              }, {
                children: dataItem.subItem
              }))]
            }))
          }), index);
        });
    }
  };

  return jsx(SearchModal, {
    className: className,
    isBodyScrollable: true,
    isFetchingMore: isFetchingMore,
    showSkeletons: _showSkeletons,
    hasMoreResults: hasMoreResults,
    onLoadMore: onLoadMore,
    onItemClick: onItemClick,
    header: {
      searchBarPlaceholder,
      onCleanClick,
      searchRef: searchRef,
      title: modalTitle,
      hasCloseBtn: true,
      showAlertMsg: showAlertMsg,
      alertMsg: alertMsg,
      onSearchChange: onSearchChange
    },
    body: handleModalBody(),
    footer: footer,
    onClose: handleCloseModal
  });
}; // eslint-disable-next-line complexity

const getCurrentModalState = ({
  hasError,
  rowsData,
  searchText,
  isFetchingMore,
  showSkeletons
}) => {
  if (hasError) return SearchModalState.ERROR_STATE;
  if (searchText && (rowsData === null || rowsData === void 0 ? void 0 : rowsData.length) === 0 && !isFetchingMore) return SearchModalState.SEARCH_EMPTY_STATE;
  if (!isFetchingMore && (rowsData === null || rowsData === void 0 ? void 0 : rowsData.length) === 0 && !showSkeletons) return SearchModalState.EMPTY_STATE;
  return SearchModalState.SUCCESSFULL_STATE;
};

/** An enumeration. */

var PractitionerStatus;

(function (PractitionerStatus) {
  /** Active */
  PractitionerStatus["Active"] = "ACTIVE";
  /** Pending */

  PractitionerStatus["Pending"] = "PENDING";
  /** Suspended */

  PractitionerStatus["Suspended"] = "SUSPENDED";
})(PractitionerStatus || (PractitionerStatus = {}));
/**
 * Component that shows a blue tag with the product name PACs as a label.
 * @author Salvador Gonzalez<salvador.gonzalez@evacenter.com>
 * Created 2023-11-21
 */


const ProductTag = ({
  option,
  textClassName,
  className,
  enableTooltip,
  locale
}) => {
  const {
    translations
  } = usePractitionerTranslations(locale);
  const classes = {
    container: cn('e-flex e-items-center e-justify-between', className),
    text: cn('e-text-sm e-font-medium e-text-neutral-50 e-truncate e-pr-2', textClassName)
  };
  const showValidPacsTag = option.hasAccess && option.status === PractitionerStatus.Active;
  const showSuspendedPacsTag = option.status === PractitionerStatus.Suspended;

  const renderTag = () => jsx(TagV2, Object.assign({
    appearance: TagV2Appearance.moderate,
    type: TagV2Type.warning,
    size: TagV2Size.xs
  }, {
    children: jsx(SimpleTooltip, Object.assign({
      position: TooltipPosition.TOP,
      description: translations.suspendedPractitioner
    }, {
      children: jsxs("div", Object.assign({
        className: "e-flex"
      }, {
        children: [jsx(Icon, {
          className: "e-text-warning-200 e-mr-1",
          icon: IconCatalog.warning,
          width: 14,
          height: 14
        }), "pacs"
        /* EvaProduct.Pacs */
        .toUpperCase()]
      }))
    }))
  }));

  return jsxs("div", Object.assign({
    className: classes.container
  }, {
    children: [jsx("div", Object.assign({
      className: classes.text
    }, {
      children: option.name
    })), showValidPacsTag && jsx(TagV2, Object.assign({
      appearance: TagV2Appearance.strong,
      type: TagV2Type.neutral,
      size: TagV2Size.xs
    }, {
      children: "pacs"
      /* EvaProduct.Pacs */
      .toUpperCase()
    })), showSuspendedPacsTag && enableTooltip && renderTag(), option.status === PractitionerStatus.Suspended && !enableTooltip && renderTag()]
  }));
};

// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$1 = functionUncurryThis;
var requireObjectCoercible$1 = requireObjectCoercible$5;
var toString$1 = toString$5;
var whitespaces$1 = whitespaces$2;

var replace = uncurryThis$1(''.replace);
var ltrim = RegExp('^[' + whitespaces$1 + ']+');
var rtrim = RegExp('(^|[^' + whitespaces$1 + '])[' + whitespaces$1 + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString$1(requireObjectCoercible$1($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var fails$1 = fails$i;
var whitespaces = whitespaces$2;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails$1(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $$2 = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$$2({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

/**
 * Get text from maybe type
 * @param {string} value value from Maybe type
 * @param defaultValue fallback value if value is not a string
 * @returns {string} return a valid string (defaultValue defined)
 */
const getTextFromMaybeType = (value, defaultValue = '') => value !== null && value !== void 0 ? value : defaultValue;

const userDTO = user => {
  return {
    id: user === null || user === void 0 ? void 0 : user.id,
    email: getTextFromMaybeType(user === null || user === void 0 ? void 0 : user.email)
  };
};

/**
 * Generates an object model to match `PractitionerType` which represents the facility data.
 * @author Alejandro Forero<alejandro.forero@evacenter.com>
 * Created 2022-09-29
 */

const referringPractitionerDTO = practitioner => {
  var _a, _b, _c, _d, _e, _f;

  return Object.assign(Object.assign({}, userDTO(practitioner.user)), {
    id: practitioner === null || practitioner === void 0 ? void 0 : practitioner.id,
    name: getTextFromMaybeType(practitioner === null || practitioner === void 0 ? void 0 : practitioner.name),
    firstSurname: getTextFromMaybeType(practitioner === null || practitioner === void 0 ? void 0 : practitioner.firstSurname),
    lastSurname: getTextFromMaybeType(practitioner === null || practitioner === void 0 ? void 0 : practitioner.lastSurname),
    fullName: getTextFromMaybeType(practitioner === null || practitioner === void 0 ? void 0 : practitioner.fullName),
    email: getTextFromMaybeType((_a = practitioner === null || practitioner === void 0 ? void 0 : practitioner.user) === null || _a === void 0 ? void 0 : _a.email),
    lastInviteDate: practitioner.lastInvitation,
    status: practitioner.status,
    hasAccess: practitioner.isValidPacsPractitioner,
    licenseNumber: getTextFromMaybeType(practitioner === null || practitioner === void 0 ? void 0 : practitioner.licenseNumber),
    phone: {
      phone: getTextFromMaybeType(practitioner === null || practitioner === void 0 ? void 0 : practitioner.phone),
      phoneCode: getTextFromMaybeType((_b = practitioner === null || practitioner === void 0 ? void 0 : practitioner.phoneCountry) === null || _b === void 0 ? void 0 : _b.phoneCode),
      isoCode: getTextFromMaybeType((_c = practitioner === null || practitioner === void 0 ? void 0 : practitioner.phoneCountry) === null || _c === void 0 ? void 0 : _c.isoCode)
    },
    specialty: {
      id: (_e = (_d = practitioner === null || practitioner === void 0 ? void 0 : practitioner.managementSpecialty) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : practitioner.specialty,
      name: getTextFromMaybeType((_f = practitioner === null || practitioner === void 0 ? void 0 : practitioner.managementSpecialty) === null || _f === void 0 ? void 0 : _f.name)
    },
    initials: getTextFromMaybeType(practitioner === null || practitioner === void 0 ? void 0 : practitioner.initials)
  });
};

/**
 * Return a value ready to be used for SelectOption / MultiSelectOption options
 * @author Alan Chávez<alan.chavez@evacenter.com>
 * Created 2022-07-22
 */
const formatSelectOption = (value, label) => ({
  label: `${label}`,
  value: value ? String(value) : ''
});
/**
 * Retrieve the value from a SelectOption object
 * @author Alan Chávez<alan.chavez@evacenter.com>
 * Created 2022-07-22
 */

const getValueFromSelectOption = option => {
  var _a;

  return (_a = option === null || option === void 0 ? void 0 : option.value) !== null && _a !== void 0 ? _a : '';
};

/**
 * Strip out empty/null values from an object.
 * @author Alan Chávez<alan.chavez@evacenter.com>
 * Created at 2022-10-12
 */
const cleanInputData = inputData => {
  const cleanedInputData = Object.keys(inputData).reduce((prevCleanedInputData, currentInputKey) => {
    // Ignore the property if its value is falsy
    if (!inputData[currentInputKey]) return prevCleanedInputData; // Only allow properties with truthy values

    return Object.assign(Object.assign({}, prevCleanedInputData), {
      [currentInputKey]: inputData[currentInputKey]
    });
  }, {});
  return cleanedInputData;
};

/**
 * Generates an object model to match `ReferringPractitionerInputType` which represents the Referring Practitioner input data.
 * @author Alan Chávez<alan.chavez@evacenter.com>
 * Created 2022-08-31
 */

const createReferringPractitionerInputDTO = (referringPractitionerFormData, facilityId) => {
  var _a, _b;

  const phoneNumber = (_a = referringPractitionerFormData === null || referringPractitionerFormData === void 0 ? void 0 : referringPractitionerFormData.phone) === null || _a === void 0 ? void 0 : _a.phone;
  const referringPractitionerInputData = Object.assign({
    name: referringPractitionerFormData === null || referringPractitionerFormData === void 0 ? void 0 : referringPractitionerFormData.name,
    firstSurname: referringPractitionerFormData === null || referringPractitionerFormData === void 0 ? void 0 : referringPractitionerFormData.firstSurname,
    lastSurname: referringPractitionerFormData === null || referringPractitionerFormData === void 0 ? void 0 : referringPractitionerFormData.lastSurname,
    licenseNumber: referringPractitionerFormData === null || referringPractitionerFormData === void 0 ? void 0 : referringPractitionerFormData.profesionalId,
    facility: facilityId,
    email: referringPractitionerFormData === null || referringPractitionerFormData === void 0 ? void 0 : referringPractitionerFormData.email,
    sendInvite: false,
    specialty: getValueFromSelectOption(referringPractitionerFormData === null || referringPractitionerFormData === void 0 ? void 0 : referringPractitionerFormData.specialty)
  }, phoneNumber && {
    phoneCode: (_b = referringPractitionerFormData === null || referringPractitionerFormData === void 0 ? void 0 : referringPractitionerFormData.phone) === null || _b === void 0 ? void 0 : _b.phoneCode,
    phoneNumber
  });
  const cleanedInputData = cleanInputData(referringPractitionerInputData); // sendInvite is a required field, but is considered as falsy if false,
  // so excluding it from the cleanInputData method validation.

  return Object.assign(Object.assign({}, cleanedInputData), {
    sendInvite: (referringPractitionerFormData === null || referringPractitionerFormData === void 0 ? void 0 : referringPractitionerFormData.sendInvite) || false
  });
};

/**
 * Generates an object model to match `CountryType` which represents a country.
 * @author Sergio Ruiz<sergio.ruiz@evacenter.com>
 * Created 2022-08-22
 */
const countryDTO = country => {
  return {
    id: country.id,
    name: country.name,
    isoCode: country.isoCode,
    phoneCode: country.phoneCode,
    isActive: country.isActive
  };
};

let _$5 = t => t,
    _t$5;
var PacsRole;

(function (PacsRole) {
  PacsRole["ADMIN"] = "admin";
  PacsRole["RADIOLOGIST_ADMIN"] = "radiologist_admin";
  PacsRole["RADIOLOGIST"] = "radiologist";
  PacsRole["RADIOLOGIST_TECHNICIAN"] = "radiologist_technician";
  PacsRole["READ_ONLY"] = "read_only";
  PacsRole["VISITANT"] = "visitant";
  PacsRole["REFERRING_PHYSICIAN"] = "referring_physician";
})(PacsRole || (PacsRole = {}));

const GetReferringPractitionersDocument = gql(_t$5 || (_t$5 = _$5`
  query getReferringPractitioners($rolesIn: [String], $search: String, $limit: Int, $offset: Int) {
    practitioners(rolesIn: $rolesIn, search: $search, limit: $limit, offset: $offset, ordering: "fullName,asc") {
      results {
        id
        licenseNumber
        phone
        phoneCode
        name
        firstSurname
        lastSurname
        fullName
        status
        isValidPacsPractitioner
        managementSpecialty {
          id
          name
        }
        phoneCountry {
          isoCode
          phoneCode
        }
        user {
          id
          email
        }
        initials
      }
      totalCount
    }
  }
`));
const UserRole = Object.assign({}, PacsRole);
/**
 * Use the `useReferringPractitioners` hook to get the Referring Practitioner list
 * @author Salvador Gonzalez<salvador.gonzalez@evacenter.com>
 */

const useGetReferringPractitioners = ({
  searchText,
  offset,
  limit,
  onFetch
}) => {
  const [referringPractitioners, setReferringPractitioners] = useState([]);
  const [totalCount, setTotalCount] = useState();
  const [isFirstLoading, setIsFirstLoading] = useState(true);
  const client = useApolloClient();
  const [hasError, setHasError] = useState(false);

  const getPractitionerVariables = () => {
    return {
      search: searchText,
      limit,
      offset,
      rolesIn: [UserRole.REFERRING_PHYSICIAN]
    };
  };

  const [getReferringPractitioners, {
    loading
  }] = useLazyQuery(GetReferringPractitionersDocument, {
    fetchPolicy: 'network-only',
    onCompleted: data => {
      var _a; // Only the first time it loads data, it is going to set this variable.


      if (isFirstLoading) setIsFirstLoading(false);
      const practitioners = data.practitioners;
      if (!(practitioners === null || practitioners === void 0 ? void 0 : practitioners.results)) return setHasError(true);
      const practitionersDataSet = (_a = practitioners === null || practitioners === void 0 ? void 0 : practitioners.results) !== null && _a !== void 0 ? _a : [];
      setTotalCount(practitioners.totalCount || 0);
      const parsePractitioners = practitionersDataSet.map(practitioner => referringPractitionerDTO(practitioner));
      setReferringPractitioners(parsePractitioners);
    },
    variables: getPractitionerVariables(),
    onError: () => {
      setHasError(true);
    }
  });

  const resetState = () => {
    setTotalCount(0);
    setIsFirstLoading(true);
    setHasError(false);
  };

  const fetchPractitioners = () => {
    getReferringPractitioners();
  };

  const handleCachedPractitioners = localPractitioners => {
    var _a;

    if (!localPractitioners) return;
    handleOnFetch();
    const referringPractitioners = (_a = localPractitioners === null || localPractitioners === void 0 ? void 0 : localPractitioners.results) !== null && _a !== void 0 ? _a : [];
    setTotalCount((localPractitioners === null || localPractitioners === void 0 ? void 0 : localPractitioners.totalCount) || 0);
    const parsedPractitioners = referringPractitioners.map(practitioner => referringPractitionerDTO(practitioner));
    setReferringPractitioners(parsedPractitioners);
    setHasError(false);
  };

  const handleOnFetch = () => {
    if (onFetch) onFetch();
  };

  useEffect(() => {
    // Get the practitioners query cached results if any to avoid unnecessary calls to the api.
    if ((searchText === null || searchText === void 0 ? void 0 : searchText.trim()) === '' && searchText !== '') return;
    const cachedPractitioners = client.readQuery({
      query: GetReferringPractitionersDocument
    });

    if (cachedPractitioners) {
      handleCachedPractitioners(cachedPractitioners.practitioners);
      return;
    }

    handleOnFetch();
    fetchPractitioners(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);
  useEffect(() => {
    fetchPractitioners(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset]);
  return {
    loading,
    totalCount,
    hasError,
    referringPractitioners,
    isFirstLoading,
    resetState,
    getReferringPractitioners
  };
};

let _$4 = t => t,
    _t$4;
const UpdateStudyReferringPractitionerDocument = gql(_t$4 || (_t$4 = _$4`
  mutation updateStudyReferringPractitioner($id: UUID!, $input: StudyInputType!) {
    updateStudy(id: $id, input: $input) {
      success
      errors
      study {
        id
      }
    }
  }
`));
/**
 * Use `useUpdateStudyReferringPractitioner` to perform the update of the study's referring practitioner
 * @author Salvador Gonzalez<salvador.gonzalez@evacenter.com>
 * Created at 2023-20-01
 */

const useUpdateStudyReferringPractitioner = ({
  onSuccess,
  onError
} = {}) => {
  const [updateStudyReferringPractitioner, {
    loading
  }] = useMutation(UpdateStudyReferringPractitionerDocument, {
    onCompleted: data => {
      if (!(data === null || data === void 0 ? void 0 : data.updateStudy.success)) if (onError) return onError();
      const study = data.updateStudy.study;
      if (onSuccess) onSuccess(study);
    },
    onError
  });
  return {
    updateStudyReferringPractitioner,
    loading
  };
};

const SearchModalFooter = ({
  onClick,
  locale
}) => {
  const {
    translations
  } = usePractitionerTranslations(locale);
  return jsx(Button, Object.assign({
    onClick: onClick && onClick,
    isFullWidth: true,
    endIcon: IconCatalog.plus,
    size: ButtonSize.sm,
    variant: ButtonVariant.tertiary
  }, {
    children: translations.emptyStateButtonText
  }));
};

var $$1 = _export;
var $includes = arrayIncludes.includes;
var fails = fails$i;
var addToUnscopables = addToUnscopables$2;

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$1({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var isObject = isObject$7;
var classof = classofRaw$2;
var wellKnownSymbol$1 = wellKnownSymbol$b;

var MATCH$1 = wellKnownSymbol$1('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof(it) === 'RegExp');
};

var isRegExp = isRegexp;

var $TypeError = TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw new $TypeError("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol = wellKnownSymbol$b;

var MATCH = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $ = _export;
var uncurryThis = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$5;
var toString = toString$5;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

var FieldTypes;

(function (FieldTypes) {
  FieldTypes["TEXTAREA"] = "LONG_TEXT";
  FieldTypes["TEXT_INPUT"] = "SHORT_TEXT";
  FieldTypes["RADIO"] = "CHOICE";
  FieldTypes["CHECKBOX"] = "MULTIPLE_CHOICE";
  FieldTypes["MULTIPLE_TEXT"] = "MULTIPLE_TEXT";
  FieldTypes["NUMBER_INPUT"] = "INTEGER";
  FieldTypes["SELECT"] = "SELECT";
  FieldTypes["SWITCH"] = "BOOLEAN";
  FieldTypes["FILE_INPUT"] = "FILE";
  FieldTypes["DATE"] = "DATE";
})(FieldTypes || (FieldTypes = {}));

const CUSTOM_EMAIL_VALIDATION = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
const CUSTOM_PASSWORD_VALIDATION_LETTERS_AND_NUMBERS = /^(?=.*[a-zA-Z])(?=.*\d)/;
const CUSTOM_PASSWORD_VALIDATION_UPPER_AND_LOWER_CASE = /(?=.*[a-z])(?=.*[A-Z])/;
const PHONE_DIGITS_VALIDATION = {
  MIN_DIGITS: 7,
  MAX_DIGITS: 18
}; // eslint-disable-next-line complexity

const validatePhone = (value = '', isOptionalPhone) => {
  if (!value && isOptionalPhone) return true;
  if (value === '') return true;
  if (!value || (value === null || value === void 0 ? void 0 : value.length) < PHONE_DIGITS_VALIDATION.MIN_DIGITS || (value === null || value === void 0 ? void 0 : value.length) > PHONE_DIGITS_VALIDATION.MAX_DIGITS) return false;
  return /^[0-9-/()\s]+$/g.test(value || '');
};
const validateEmail = (value = '') => {
  if (!value) return true;
  return CUSTOM_EMAIL_VALIDATION.test(value);
};
const validatePasswordLettersAndNumbers = (value = '') => {
  if (!value) return true;
  return CUSTOM_PASSWORD_VALIDATION_LETTERS_AND_NUMBERS.test(value);
};
const validatePasswordUpperAndLowerCase = (value = '') => {
  if (!value) return true;
  return CUSTOM_PASSWORD_VALIDATION_UPPER_AND_LOWER_CASE.test(value);
};
const getPhoneField = (translations, isRequired = false) => {
  return getTextField(translations, isRequired).test('phoneFormat', translations.wrongPhoneFormat, value => validatePhone(value));
};
const getPhoneOptionalField = translations => {
  return getTextField(translations).test('phoneFormat', translations.wrongPhoneFormat, value => validatePhone(value, true)).nullable().optional();
};
const getEmailField = (translations, isRequired = false) => {
  let field = getTextField(translations, isRequired).test('emailFormat', translations.wrongEmailFormat, value => validateEmail(value !== null && value !== void 0 ? value : ''));
  if (isRequired) field = field.required(translations.requiredField);
  return field;
};
const getTextField = (translations, isRequired = false) => {
  let field = yup.string().trim();
  if (isRequired) field = field.required(translations.requiredField);
  return field;
};
const getDateField = (translations, isRequired = false) => {
  let field = yup.date().nullable();
  if (isRequired) field = field.required(translations.requiredField);
  return field;
};
const getPhoneObjectField = (translations, isRequired = false) => yup.object({
  phone: getPhoneField(translations, isRequired),
  phoneCode: getTextField(translations)
});
const getPhoneObjectOptionalField = translations => yup.object({
  phone: getPhoneOptionalField(translations),
  phoneCode: getTextField(translations)
});
const getLazyField = schema => yup.lazy(value => {
  if (value !== undefined) return schema;
  return yup.mixed().notRequired();
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any

const getDynamicSchema = (translations, listFields) => {
  const fields = listFields === null || listFields === void 0 ? void 0 : listFields.reduce((prevFields, field) => Object.assign(Object.assign({}, prevFields), {
    [field === null || field === void 0 ? void 0 : field.name]: getFieldControl(translations, field)
  }), {});
  return yup.object().shape(fields);
};
const getFieldControl = (translations, formField) => {
  const {
    isRequired,
    type
  } = formField;

  switch (type) {
    case FieldTypes.DATE:
      return getDateField(translations, isRequired);

    default:
      return getTextField(translations, isRequired);
  }
};

const studyFormSchema = translations => {
  return yup.object({
    id: getTextField(translations).optional(),
    toWhomItMayConcern: yup.boolean(),
    referringPhysicianId: getTextField(translations).nullable().optional(),
    showInvitation: yup.boolean(),
    referringPhysician: yup.object().when(['referringPhysicianId', 'toWhomItMayConcern'], {
      is: (referringPhysicianId, toWhomItMayConcern) => !referringPhysicianId && !toWhomItMayConcern,
      then: schema => schema.shape({
        name: getTextField(translations, true),
        firstSurname: getTextField(translations, true),
        lastSurname: getTextField(translations).nullable(),
        email: getEmailField(translations, false),
        sendInvite: yup.boolean(),
        phone: yup.object({
          phone: getPhoneField(translations),
          phoneCode: getTextField(translations)
        }),
        specialty: yup.object({
          value: getTextField(translations, false).optional().nullable()
        }),
        profesionalId: getTextField(translations).optional().nullable(),
        facilityId: getTextField(translations).optional().nullable()
      })
    })
  });
};

const StudyFormProvider = ({
  children,
  defaultValues,
  locale
}) => {
  const {
    translations
  } = usePractitionerTranslations(locale);
  const methods = useForm({
    criteriaMode: 'all',
    mode: 'all',
    resolver: yupResolver(studyFormSchema(translations)),
    defaultValues
  });
  return jsx(FormProvider, Object.assign({}, methods, {
    children: children
  }));
};
/**
 * Use `useOrderFormContext` to get data from the current `StudyFormProvider`
 * @author Salvador Gonzalez<salvador.gonzalez@evacenter.com>
 * Created at 2023-20-01
 */

const useStudyFormContext = () => useFormContext();

let _$3 = t => t,
    _t$3;
const CreateReferringPractitionerDocument = gql(_t$3 || (_t$3 = _$3`
  mutation createReferringPractitioner($input: ReferringPractitionerInputType!) {
    createReferringPractitioner(input: $input) {
      success
      errors
      practitioner {
        id
        fullName
      }
    }
  }
`));
/**
 * Use the `useCreateReferringPractitioner` hook to create a new Referring Practitioner
 * @author Alan Chávez<alan.chavez@evacenter.com>
 */

const useCreateReferringPractitioner = options => {
  const {
    onSuccess,
    onError
  } = options !== null && options !== void 0 ? options : {};
  const [createReferringPractitionerMutation, {
    data: referringPractitionerData,
    loading
  }] = useMutation(CreateReferringPractitionerDocument, {
    // eslint-disable-next-line complexity
    onCompleted: data => {
      var _a, _b, _c;

      if (!((_a = data === null || data === void 0 ? void 0 : data.createReferringPractitioner) === null || _a === void 0 ? void 0 : _a.practitioner) || !((_b = data === null || data === void 0 ? void 0 : data.createReferringPractitioner) === null || _b === void 0 ? void 0 : _b.success)) if (onError) return onError();
      const practitioner = referringPractitionerDTO((_c = data === null || data === void 0 ? void 0 : data.createReferringPractitioner) === null || _c === void 0 ? void 0 : _c.practitioner);
      if (!practitioner && onError) return onError();
      if (!practitioner) return;
      if (onSuccess) onSuccess(practitioner);
    },
    onError
  });

  const createReferringPractitioner = referringPractitionerInput => {
    createReferringPractitionerMutation({
      variables: {
        input: referringPractitionerInput
      }
    });
  };

  return {
    createReferringPractitioner,
    referringPractitionerData,
    loading
  };
};

/**
 * `useReferringPractitionerForm` works as a middleware for when interacting with
 * forms that holds referring practitioner changes which allows to create or not referring practitioners.
 * @author Salvador Gonzalez<salvador.gonzalez@edenmed.com>
 * Created at 2022-10-14
 */

const useReferringPractitionerForm = ({
  onSuccess,
  onError,
  facilityId
}) => {
  const onCreatePhysicianError = () => {
    if (onError) onError();
  };

  const {
    createReferringPractitioner,
    loading: createPhysicianLoading
  } = useCreateReferringPractitioner({
    onSuccess: physician => {
      if (onSuccess) onSuccess(physician === null || physician === void 0 ? void 0 : physician.id);
    },
    onError: onCreatePhysicianError
  });

  const onSubmit = formData => {
    // There's already a `referringPractitioner` avoid creating a new one.
    if (((formData === null || formData === void 0 ? void 0 : formData.referringPhysicianId) || formData.toWhomItMayConcern) && onSuccess) return onSuccess((formData === null || formData === void 0 ? void 0 : formData.referringPhysicianId) || '');
    const referringPractitionerInput = createReferringPractitionerInputDTO(formData === null || formData === void 0 ? void 0 : formData.referringPhysician, facilityId || '');
    createReferringPractitioner(referringPractitionerInput);
  };

  return {
    onSubmit,
    isSubmitting: createPhysicianLoading
  };
};

/**
 * @param phoneObject Object with phone data separate between number and code
 * @returns phone number with this format: +yyyzzzzzzzz where yyy is code and zzzzzzzz is number
 */
const getPhoneNumberString = phoneObject => (phoneObject === null || phoneObject === void 0 ? void 0 : phoneObject.phone) && (phoneObject === null || phoneObject === void 0 ? void 0 : phoneObject.phoneCode) ? `+${phoneObject.phoneCode}${phoneObject.phone}` : '';

/**
 * `getHasNextPage` calculates if a query has more items to retrieve (next page)
 * by a given `totalItemsAmount` and `currentItemsAmount`
 * @author Salvador Gonzalez<salvador.gonzalez@evacenter.com>
 * Created at 2022-10-19
 */
const getHasNextPage = (totalItemsAmount, currentItemsAmount) => totalItemsAmount - currentItemsAmount - 1 > 0;

/**
 * Represents a ReferringPractitioner item of the Companies List
 * @author Sergio Ruiz<sergioruizdavila@gmail.com>
 * Created at 2022-08-24
 */

const ReferringPractitionerOption = ({
  className,
  option,
  onClick
}) => {
  const classes = cn(className, 'e-flex e-flex-col', 'e-p-4', 'hover:e-bg-neutral-700  e-border-b e-border-neutral-500');

  const handleClick = () => {
    if (onClick) onClick(option);
  };
  /* Render JSX */


  return jsxs("div", Object.assign({
    role: "option",
    tabIndex: -1,
    className: classes,
    onClick: handleClick,
    onKeyUp: handleClick,
    "aria-selected": true
  }, {
    children: [jsxs("div", Object.assign({
      className: "e-flex e-items-center w-full e-mb-2 e-justify-between"
    }, {
      children: [jsx("div", Object.assign({
        className: "e-text-base e-font-medium e-text-neutral-50 e-truncate e-pr-4"
      }, {
        children: option.fullName
      })), option.hasAccess && option.status === PractitionerStatus.Active && jsx(Tag, Object.assign({
        variant: TagVariant.primary,
        hasStroke: true
      }, {
        children: "pacs"
        /* EvaProduct.Pacs */
        .toUpperCase()
      }))]
    })), jsxs("div", Object.assign({
      className: "e-flex e-items-start e-text-xs e-text-neutral-200 e-font-light e-flex-col"
    }, {
      children: [jsx("div", Object.assign({
        className: " e-mb-1"
      }, {
        children: option.email
      })), jsx("div", {
        children: getPhoneNumberString(option.phone)
      })]
    }))]
  }));
};

const TypeaheadDebounceTime = 500;
const TypeaheadQueryLimit = 20;
/**
  Represents a ReferringPractitioner item of the ReferringPractitioners Data List
  @author Sergio Ruiz<sergioruizdavila@gmail.com>
  Created at 2022-08-23
 */

const ReferringPractitionerName = _a => {
  var {
    className,
    value,
    onInputChange,
    onOptionClick
  } = _a,
      restOfProps = __rest(_a, ["className", "value", "onInputChange", "onOptionClick"]);

  const classes = cn(className);
  const [inputValue, setInputValue] = useState(value);
  const {
    getReferringPractitioners,
    referringPractitioners: referringPractitionersDataSet,
    loading
  } = useGetReferringPractitioners({});
  const debouncedSearchTerm = useDebounce(inputValue, TypeaheadDebounceTime);
  const isInputEmpty = useMemo(() => debouncedSearchTerm === '' || debouncedSearchTerm === null || !debouncedSearchTerm, [debouncedSearchTerm]);
  const referringPractitioners = !isInputEmpty ? referringPractitionersDataSet : [];
  useEffect(() => {
    setInputValue(value);
  }, [value]);
  useEffect(() => {
    if (isInputEmpty) return;
    getReferringPractitioners({
      variables: {
        search: debouncedSearchTerm,
        limit: TypeaheadQueryLimit
      }
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm]);

  const handleInputChange = event => {
    setInputValue(event.target.value);
    if (onInputChange) onInputChange(event);
  };

  const handleOptionClick = onCloseMenu => option => {
    setInputValue(option.name);
    if (onOptionClick) onOptionClick(option);
    onCloseMenu();
  };

  const renderOption = (option, index, onCloseMenu) => jsx(ReferringPractitionerOption, {
    option: option,
    onClick: handleOptionClick(onCloseMenu)
  }, index);
  /* Render JSX */


  return jsx(Typeahead, Object.assign({
    className: classes,
    options: referringPractitioners,
    renderOption: (option, index, onCloseMenu) => renderOption(option, index, onCloseMenu),
    onChange: handleInputChange,
    value: inputValue,
    isLoading: loading
  }, restOfProps));
};

let _$2 = t => t,
    _t$2;
const GetCountriesDocument = gql(_t$2 || (_t$2 = _$2`
  query getCountries {
    countries(ordering: "name,asc") {
      results {
        name
        id
        isoCode
        iso3Code
        phoneCode
        isoCode
        isActive
      }
    }
  }
`));
/**
 * Use the `useCountries` hook to get the Countries Data list
 * @author Sergio Ruiz<sergio.ruiz@evacenter.com>
 */

const useCountries = () => {
  const [countries, setCountries] = useState([]);
  const isoCodeCountriesMapRef = useRef();
  const isoCodeCountriesMap = useMemo(() => {
    const parsedCountries = countries.reduce((prevCodes, currentCountry) => Object.assign(Object.assign({}, prevCodes), {
      [currentCountry.isoCode]: currentCountry.id
    }), {});
    isoCodeCountriesMapRef.current = parsedCountries;
    return parsedCountries;
  }, [countries]);
  const {
    loading
  } = useQuery(GetCountriesDocument, {
    onCompleted: data => {
      var _a;

      const countries = (_a = data === null || data === void 0 ? void 0 : data.countries) === null || _a === void 0 ? void 0 : _a.results;
      if (!(countries === null || countries === void 0 ? void 0 : countries.length)) return;
      const parsedCountries = countries.map(country => countryDTO(country));
      setCountries(parsedCountries);
    }
  });
  return {
    loading,
    countries,
    isoCodeCountriesMap,
    isoCodeCountriesMapRef
  };
};

let _$1 = t => t,
    _t$1;
const GetFacilityLocationDocument = gql(_t$1 || (_t$1 = _$1`
  query getFacilityLocation($facilityId: UUID) {
    facility(id: $facilityId) {
      id
      address
      postalCode
      city {
        id
        name
      }
      state {
        id
        name
      }
      country {
        id
        name
        phoneCode
        isoCode
      }
    }
  }
`));
const useFacilityLocation = options => {
  const {
    onSuccess,
    onError,
    facilityId,
    skip = false
  } = options !== null && options !== void 0 ? options : {};
  const {
    data: facilityLocationData,
    loading
  } = useQuery(GetFacilityLocationDocument, {
    skip,
    variables: {
      facilityId: facilityId || ''
    },
    onCompleted: data => {
      if (!(data === null || data === void 0 ? void 0 : data.facility)) return;
      if (onSuccess) onSuccess(data.facility);
    },
    onError
  });
  return {
    facilityLocationData,
    loading
  };
};

/**
 * Use the `useFormFieldState` hook to retrieve the state of a field using a `path` string like react-hook-form does.
 * @author Alan Chávez<alan.chavez@evacenter.com>
 * Created at 2022-08-10
 */

const useFormFieldState = formState => {
  var _a, _b;

  const {
    formState: formStateContext
  } = (_a = useFormContext()) !== null && _a !== void 0 ? _a : {};
  const formErrors = (_b = formState === null || formState === void 0 ? void 0 : formState.errors) !== null && _b !== void 0 ? _b : formStateContext.errors;

  const getFormFieldState = field => {
    const hasError = get$1(formErrors, field);
    if (hasError) return FormFieldState.error;
    return FormFieldState.default;
  };

  return {
    getFormFieldState
  };
};

const useReferringPhysicianFormData = () => {
  const {
    reset,
    getValues,
    watch
  } = useFormContext();
  const hasSelectedReferringPhysician = !!watch('referringPhysicianId');

  const setPhysicianValues = physician => {
    reset(Object.assign(Object.assign({}, getValues()), {
      referringPhysicianId: physician.id,
      referringPhysician: {
        name: physician.name,
        firstSurname: physician.firstSurname,
        lastSurname: physician.lastSurname,
        email: physician.email,
        specialty: formatSelectOption(physician.specialty.id, physician.specialty.name),
        status: physician.status,
        lastInviteDate: physician.lastInviteDate,
        profesionalId: physician.licenseNumber,
        phone: physician.phone,
        sendInvite: !physician.hasAccess
      },
      showInvitation: !physician.hasAccess
    }));
  };

  const resetPhysicianValues = () => {
    reset(Object.assign(Object.assign({}, getValues()), {
      showInvitation: true,
      referringPhysicianId: '',
      referringPhysician: {
        name: '',
        firstSurname: '',
        lastSurname: '',
        email: '',
        status: '',
        lastInviteDate: '',
        phone: {
          phone: '',
          phoneCode: '',
          isoCode: ''
        },
        specialty: {
          value: '',
          label: ''
        },
        profesionalId: '',
        facilityId: '',
        sendInvite: true
      }
    }));
  };

  return {
    setPhysicianValues,
    resetPhysicianValues,
    hasSelectedReferringPhysician
  };
};

const MIN_DIGIT_EMAIL_SIZE = 3;
/**
 * Hook that validates an email form field with FormFieldState helpers and a min digit amount
 * for the components to know if its a valid email field and perform some actions over it.
 * @author Salvador Gonzalez<salvador.gonzalez@edenmed.com>
 * Created at 2023-10-09
 */

const useValidateEmail = ({
  emailValue,
  getFormFieldState,
  fieldName
}) => {
  const isValidEmailField = useMemo(() => {
    if (getFormFieldState(fieldName) !== FormFieldState.error && emailValue) {
      if (emailValue.length < MIN_DIGIT_EMAIL_SIZE) return false;
      return true;
    }

    return false; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailValue]);
  return {
    isValidEmailField
  };
};

const DEFAULT_COUNTRY = 'Mexico';
const DEFAULT_COUNTRY_ISO_CODE = 'MX';
const DEFAULT_COUNTRY_PHONE_CODE = '52';
const DEFAULT_PHONE_COUNTRY = {
  name: DEFAULT_COUNTRY,
  isoCode: DEFAULT_COUNTRY_ISO_CODE,
  phoneCode: DEFAULT_COUNTRY_PHONE_CODE
};
const DEFAULT_PHONE_PLACEHOLDER = '(XX)-XXXX-XXXX';
/**
 * `PhoneInputField` provides a phone input field that can default its phoneCode according to the user's facility if needed.
 * @author Alan Chávez<alan.chavez@evacenter.com>
 * Created at 2023-07-05
 */

const PhoneInputField = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
    value,
    enableFacilityPhoneFallback = true,
    facilityId
  } = _a,
      restProps = __rest(_a, ["value", "enableFacilityPhoneFallback", "facilityId"]);

  const {
    countries
  } = useCountries();
  const {
    facilityLocationData
  } = useFacilityLocation({
    skip: !enableFacilityPhoneFallback,
    facilityId: facilityId
  });
  const facilityPhone = useMemo(() => {
    var _a, _b, _c, _d, _e, _f;

    const phoneCode = (_c = (_b = (_a = facilityLocationData === null || facilityLocationData === void 0 ? void 0 : facilityLocationData.facility) === null || _a === void 0 ? void 0 : _a.country) === null || _b === void 0 ? void 0 : _b.phoneCode) !== null && _c !== void 0 ? _c : '';
    const isoCode = (_f = (_e = (_d = facilityLocationData === null || facilityLocationData === void 0 ? void 0 : facilityLocationData.facility) === null || _d === void 0 ? void 0 : _d.country) === null || _e === void 0 ? void 0 : _e.isoCode) !== null && _f !== void 0 ? _f : '';
    return {
      phoneCode,
      isoCode
    };
  }, [facilityLocationData]);

  const getDefaultCountryCode = () => {
    if (value === null || value === void 0 ? void 0 : value.phoneCode) return value.phoneCode;
    if (enableFacilityPhoneFallback && (facilityPhone === null || facilityPhone === void 0 ? void 0 : facilityPhone.phoneCode)) return facilityPhone.phoneCode;
    return DEFAULT_PHONE_COUNTRY.phoneCode;
  };

  const getDefaultCountryIsoCode = () => {
    // The phone does have a `phoneCode` but `isoCode` is absent, so do nothing.
    if ((value === null || value === void 0 ? void 0 : value.phoneCode) && !(value === null || value === void 0 ? void 0 : value.isoCode)) return; // There's already an isoCode, use it

    if (value === null || value === void 0 ? void 0 : value.isoCode) return value === null || value === void 0 ? void 0 : value.isoCode;
    if (enableFacilityPhoneFallback && (facilityPhone === null || facilityPhone === void 0 ? void 0 : facilityPhone.isoCode)) return facilityPhone.isoCode;
    return DEFAULT_PHONE_COUNTRY.isoCode;
  };

  return jsx(PhoneInput, Object.assign({
    ref: ref
  }, restProps, {
    defaultCountryCode: getDefaultCountryCode(),
    defaultCountryIsoCode: getDefaultCountryIsoCode(),
    countryCodes: countries,
    value: value === null || value === void 0 ? void 0 : value.phone,
    placeholder: DEFAULT_PHONE_PLACEHOLDER
  }));
});
PhoneInputField.displayName = 'PhoneInputField';

let _ = t => t,
    _t;
const GetSpecialtiesOptionsDocument = gql(_t || (_t = _`
  query getSpecialtiesOptions {
    specialties(ordering: "name,asc") {
      results {
        id
        name
      }
    }
  }
`));
const ReferringPractitionerFormFields = ({
  facilityId,
  renderTypeheadName: _renderTypeheadName = true,
  showToWhomItMayConcern: _showToWhomItMayConcern = true,
  canEditPractitioner: _canEditPractitioner = true,
  locale
}) => {
  const [emailValue, setEmailValue] = useState('');
  const {
    translations
  } = usePractitionerTranslations(locale);
  const [specialtiesOptions, setSpecialtiesOptions] = useState([]);
  const {
    getFormFieldState
  } = useFormFieldState();
  const {
    control,
    formState: {
      errors
    },
    setValue,
    watch
  } = useStudyFormContext();
  const toWhomItMayConcernWatch = watch('toWhomItMayConcern');
  const {
    setPhysicianValues,
    hasSelectedReferringPhysician,
    resetPhysicianValues
  } = useReferringPhysicianFormData();
  const {
    loading: specialtiesOptionsLoading
  } = useQuery(GetSpecialtiesOptionsDocument, {
    onCompleted: response => {
      if (!response.specialties) return;
      const parsedOptions = response.specialties.results.map(specialty => ({
        value: specialty.id,
        label: specialty.name
      }));
      setSpecialtiesOptions(parsedOptions);
    }
  });
  const physicianStatus = watch('referringPhysician.status');
  const lastInvitation = watch('referringPhysician.lastInviteDate');
  const showInvitationWatch = watch('showInvitation');
  const isInputDisabled = hasSelectedReferringPhysician || !_canEditPractitioner;
  const {
    isValidEmailField
  } = useValidateEmail({
    fieldName: 'referringPhysician.email',
    getFormFieldState,
    emailValue: emailValue
  });
  useEffect(() => {
    if (isValidEmailField) return setValue('referringPhysician.sendInvite', true);
    return setValue('referringPhysician.sendInvite', false); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValidEmailField]);
  const shouldRenderInviteCheckbox = useMemo(() => {
    if (!physicianStatus) return true;
    return physicianStatus === PractitionerStatus.Pending && !lastInvitation;
  }, [physicianStatus, lastInvitation]);

  const renderPractitionerFieldComponent = (name, value, onChange) => {
    var _a, _b, _c, _d;

    if (_renderTypeheadName) return jsx(ReferringPractitionerName, Object.assign({
      name: name,
      value: value || '',
      onInputChange: onChange,
      onOptionClick: setPhysicianValues,
      label: translations.name,
      isRequired: true,
      placeholder: translations.refDoctorName,
      fieldState: getFormFieldState('referringPhysician.name'),
      assistiveText: (_b = (_a = errors.referringPhysician) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.message,
      autoComplete: "off",
      isDisabled: !_canEditPractitioner,
      isReadOnly: hasSelectedReferringPhysician
    }, hasSelectedReferringPhysician && _canEditPractitioner && {
      endIcon: IconCatalog.close,
      onEndIconClick: resetPhysicianValues
    }));
    return jsx(TextInput, {
      label: translations.name,
      isRequired: true,
      placeholder: translations.refDoctorName,
      name: name,
      value: value || '',
      onChange: onChange,
      fieldState: getFormFieldState('referringPhysician.name'),
      assistiveText: (_d = (_c = errors.referringPhysician) === null || _c === void 0 ? void 0 : _c.name) === null || _d === void 0 ? void 0 : _d.message,
      isDisabled: isInputDisabled
    });
  };

  const renderContent = () => {
    if (toWhomItMayConcernWatch) return null;
    return jsxs(Fragment, {
      children: [_canEditPractitioner && jsx("div", Object.assign({
        className: "e-flex e-flex-col e-space-y-2"
      }, {
        children: jsx("p", Object.assign({
          className: "e-text-base e-font-regular"
        }, {
          children: translations.disclaimerRequiredFields
        }))
      })), jsxs("fieldset", Object.assign({
        className: "e-grid e-grid-cols-3 e-gap-6"
      }, {
        children: [jsx(Controller, {
          name: "referringPhysician.name",
          control: control,
          render: ({
            field: {
              name,
              value,
              onChange
            }
          }) => renderPractitionerFieldComponent(name, value, onChange)
        }), jsx(Controller, {
          name: "referringPhysician.firstSurname",
          control: control,
          render: ({
            field: {
              name,
              value,
              onChange
            }
          }) => {
            var _a, _b;

            return jsx(TextInput, {
              label: translations.firstSurname,
              isRequired: true,
              placeholder: translations.refDoctorFirstName,
              name: name,
              value: value || '',
              onChange: onChange,
              fieldState: getFormFieldState('referringPhysician.firstSurname'),
              assistiveText: (_b = (_a = errors.referringPhysician) === null || _a === void 0 ? void 0 : _a.firstSurname) === null || _b === void 0 ? void 0 : _b.message,
              isDisabled: isInputDisabled
            });
          }
        }), jsx(Controller, {
          name: "referringPhysician.lastSurname",
          control: control,
          render: ({
            field: {
              name,
              value,
              onChange
            }
          }) => {
            var _a, _b;

            return jsx(TextInput, {
              label: translations.secondSurname,
              placeholder: translations.refDoctorSecondSurname,
              name: name,
              value: value || '',
              onChange: onChange,
              fieldState: getFormFieldState('referringPhysician.lastSurname'),
              assistiveText: (_b = (_a = errors.referringPhysician) === null || _a === void 0 ? void 0 : _a.lastSurname) === null || _b === void 0 ? void 0 : _b.message,
              isDisabled: isInputDisabled
            });
          }
        })]
      })), jsxs("fieldset", Object.assign({
        className: "e-grid e-grid-cols-3 e-gap-6"
      }, {
        children: [jsx(Controller, {
          name: "referringPhysician.email",
          control: control,
          render: ({
            field: {
              name,
              value,
              onChange
            }
          }) => {
            var _a, _b;

            setEmailValue(value);
            return jsx(TextInput, {
              label: translations.email,
              placeholder: translations.refDoctorEmail,
              name: name,
              value: value || '',
              onChange: onChange,
              fieldState: getFormFieldState('referringPhysician.email'),
              assistiveText: (_b = (_a = errors.referringPhysician) === null || _a === void 0 ? void 0 : _a.email) === null || _b === void 0 ? void 0 : _b.message,
              isDisabled: isInputDisabled
            });
          }
        }), jsx(Controller, {
          name: "referringPhysician.phone",
          control: control,
          render: ({
            field: {
              name,
              value,
              onChange
            }
          }) => {
            var _a, _b;

            return jsx(PhoneInputField, {
              value: value,
              facilityId: facilityId,
              name: name,
              label: translations.phone,
              fieldState: getFormFieldState('referringPhysician.phone'),
              assistiveText: (_b = (_a = errors.referringPhysician) === null || _a === void 0 ? void 0 : _a.phone) === null || _b === void 0 ? void 0 : _b.message,
              onInputChange: onChange,
              isDisabled: isInputDisabled
            });
          }
        })]
      })), jsxs("fieldset", Object.assign({
        className: "e-grid e-grid-cols-3 e-gap-6"
      }, {
        children: [jsx(Controller, {
          name: "referringPhysician.specialty",
          control: control,
          render: ({
            field: {
              name,
              value,
              onChange
            }
          }) => {
            var _a, _b, _c;

            return jsx(SelectV2, {
              name: name,
              value: value === null || value === void 0 ? void 0 : value.value,
              selectContentClassName: "e-z-50",
              onChange: onChange,
              label: translations.specialty,
              placeholder: translations.singleSelectionPlaceholder,
              fieldState: getFormFieldState('referringPhysician.specialty'),
              options: specialtiesOptions,
              isLoading: specialtiesOptionsLoading,
              isDisabled: isInputDisabled,
              assistiveText: (_c = (_b = (_a = errors === null || errors === void 0 ? void 0 : errors.referringPhysician) === null || _a === void 0 ? void 0 : _a.specialty) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.message
            });
          }
        }), jsx(Controller, {
          name: "referringPhysician.profesionalId",
          control: control,
          render: ({
            field: {
              name,
              value,
              onChange
            }
          }) => {
            var _a, _b;

            return jsx(TextInput, {
              label: translations.proLicense,
              placeholder: translations.doctorLicense,
              name: name,
              value: value || '',
              onChange: onChange,
              fieldState: getFormFieldState('referringPhysician.profesionalId'),
              assistiveText: (_b = (_a = errors.referringPhysician) === null || _a === void 0 ? void 0 : _a.profesionalId) === null || _b === void 0 ? void 0 : _b.message,
              isDisabled: isInputDisabled
            });
          }
        })]
      })), jsx("fieldset", Object.assign({
        className: "e-flex e-flex-col e-space-y-4"
      }, {
        children: showInvitationWatch && shouldRenderInviteCheckbox && jsx(Controller, {
          name: "referringPhysician.sendInvite",
          control: control,
          defaultValue: true,
          render: ({
            field: {
              name,
              value,
              onChange
            }
          }) => jsx(Checkbox, {
            isDisabled: !isValidEmailField,
            label: translations.inviteRefDoctor,
            name: name,
            defaultChecked: value,
            checked: value,
            onChange: onChange
          })
        })
      }))]
    });
  };

  return jsxs("div", Object.assign({
    className: "e-flex e-flex-col e-space-y-6"
  }, {
    children: [_canEditPractitioner && _showToWhomItMayConcern && jsx("fieldset", Object.assign({
      className: "e-flex e-flex-col e-space-y-4"
    }, {
      children: jsx(Controller, {
        name: "toWhomItMayConcern",
        control: control,
        defaultValue: false,
        render: ({
          field: {
            name,
            value,
            onChange
          }
        }) => jsx(Switch, {
          label: translations.toWhomItMayConcern,
          name: name,
          value: value,
          onChange: checked => {
            onChange(checked);
            if (checked) resetPhysicianValues();
          }
        })
      })
    })), renderContent()]
  }));
};

const ReferringPhysicianSectionForm = ({
  onSubmit,
  onError,
  actions,
  renderTypeheadName,
  facilityId,
  showToWhomItMayConcern,
  locale
}) => {
  const {
    handleSubmit
  } = useStudyFormContext();
  return jsxs("form", Object.assign({
    "data-testid": "referring-physician-section-form",
    noValidate: true,
    onSubmit: handleSubmit(onSubmit, onError),
    className: "e-flex e-flex-col e-space-y-6"
  }, {
    children: [jsx(ReferringPractitionerFormFields, {
      facilityId: facilityId,
      locale: locale,
      showToWhomItMayConcern: showToWhomItMayConcern,
      renderTypeheadName: renderTypeheadName
    }), actions]
  }));
};

/**
 * Create practitioner form that shows practitioners fields to create a new practitioner.
 * @author Salvador Gonzalez<salvador.gonzalez@evacenter.com>
 * Created 2023-11-21
 */

const CreatePractitionerModal = ({
  onUpdateStudyReferringPractitioner,
  modalityPractitioner,
  showInlineAlert,
  hasEditPermissions,
  onClose,
  onSuccess,
  locale,
  facilityId,
  onErrorSubmit,
  onError
}) => {
  const {
    translations
  } = usePractitionerTranslations(locale);
  const {
    getValues,
    setValue
  } = useStudyFormContext();

  const getFullName = formValues => {
    var _a, _b, _c;

    const parts = [(_a = formValues.referringPhysician) === null || _a === void 0 ? void 0 : _a.name, (_b = formValues.referringPhysician) === null || _b === void 0 ? void 0 : _b.firstSurname, (_c = formValues.referringPhysician) === null || _c === void 0 ? void 0 : _c.lastSurname];
    return parts.filter(Boolean).join(' ');
  };

  const {
    onSubmit,
    isSubmitting
  } = useReferringPractitionerForm({
    facilityId,
    onSuccess: physicianId => {
      // A new physician has been created, save it in the form data.
      const formValues = getValues();
      const fullName = getFullName(formValues);
      const input = formValues.toWhomItMayConcern ? {
        referringPractitioner: null,
        dicomReferringPhysician: null,
        dicomRequestingPhysician: null,
        referringPhysicianName: fullName
      } : {
        referringPractitioner: physicianId
      };
      if (physicianId) setValue('referringPhysicianId', physicianId);
      if (onSuccess) onSuccess({
        fullName,
        id: physicianId
      });
      if (onUpdateStudyReferringPractitioner) onUpdateStudyReferringPractitioner(input);
      if (onClose) onClose();
    },
    onError: () => {
      if (onError) onError();
    }
  });
  if (!hasEditPermissions) return null;

  const renderActions = () => {
    return jsxs("div", Object.assign({
      className: "e-w-full e-flex e-justify-between"
    }, {
      children: [jsx(Button, Object.assign({
        onClick: () => {
          if (onClose) onClose();
        },
        startIcon: IconCatalog.arrowLeft,
        size: ButtonSize.sm,
        variant: ButtonVariant.tertiary
      }, {
        children: translations.goBack
      })), jsx(Button, Object.assign({
        isLoading: isSubmitting,
        isDisabled: isSubmitting,
        type: "submit",
        size: ButtonSize.sm,
        variant: ButtonVariant.primary
      }, {
        children: translations.confirm
      }))]
    }));
  };

  const handleOnErrorSubmit = () => {
    if (onErrorSubmit) onErrorSubmit();
  };

  return jsxs("div", Object.assign({
    className: "e-text-neutral-50"
  }, {
    children: [modalityPractitioner && showInlineAlert && jsx(InlineAlert, {
      className: "e-mb-6",
      variant: InlineAlertVariant.warning,
      description: `${translations.modalityPractitionerDescription}  ${modalityPractitioner}`
    }), jsx(ReferringPhysicianSectionForm, {
      locale: locale,
      facilityId: facilityId,
      showToWhomItMayConcern: false,
      actions: renderActions(),
      renderTypeheadName: false,
      onError: handleOnErrorSubmit,
      onSubmit: onSubmit
    })]
  }));
};

const useSearchModalFooter = ({
  studyId,
  facilityId,
  locale,
  onSuccessUpdate,
  onErrorUpdate,
  modalityPractitionerName,
  onClose,
  onOpenFooterModal,
  hasEditPermissions,
  showInlineAlert,
  onCloseFooterModal,
  onSuccessPractitionerCreation
}) => {
  const {
    translations
  } = usePractitionerTranslations(locale);
  const newPractitionerRef = React.useRef();
  const {
    modalNode,
    openModal
  } = useModal();
  const {
    updateStudyReferringPractitioner
  } = useUpdateStudyReferringPractitioner({
    onSuccess: () => {
      var _a, _b;

      const practitionerId = ((_a = newPractitionerRef === null || newPractitionerRef === void 0 ? void 0 : newPractitionerRef.current) === null || _a === void 0 ? void 0 : _a.id) || '';
      const practitionerName = ((_b = newPractitionerRef === null || newPractitionerRef === void 0 ? void 0 : newPractitionerRef.current) === null || _b === void 0 ? void 0 : _b.name) || '';
      if (onSuccessUpdate) onSuccessUpdate(practitionerId, practitionerName);
      if (onClose) onClose();
    },
    onError: () => {
      if (onErrorUpdate) onErrorUpdate();
    }
  });

  const handleUpdateNewlyPractitionerCreated = input => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const rest = __rest(input, ["referringPhysicianName"]);

    return updateStudyReferringPractitioner({
      variables: {
        id: studyId,
        input: rest
      }
    });
  };

  const handleOnSuccessPractitionerCreation = ({
    fullName,
    id
  }) => {
    newPractitionerRef.current = {
      name: fullName,
      id
    };
    if (onSuccessPractitionerCreation) onSuccessPractitionerCreation(fullName);
  };

  const handleCreatePractitioner = (currentText = '') => __awaiter(void 0, void 0, void 0, function* () {
    const physicianDefaultValues = {
      referringPhysician: generateDefaultValues(currentText)
    };
    yield openModal(close => {
      if (onOpenFooterModal) onOpenFooterModal();
      return jsx(BaseModal, {
        size: ModalSize.lg,
        onClose: () => {
          if (onCloseFooterModal) onCloseFooterModal();
          close();
        },
        header: {
          title: translations.emptyStateButtonText,
          hasCloseBtn: true
        },
        body: jsx(StudyFormProvider, Object.assign({
          locale: locale,
          defaultValues: Object.assign({
            showInvitation: true
          }, physicianDefaultValues)
        }, {
          children: jsx(CreatePractitionerModal, {
            onClose: () => {
              if (onCloseFooterModal) onCloseFooterModal();
              close();
            },
            hasEditPermissions: hasEditPermissions,
            locale: locale,
            onSuccess: handleOnSuccessPractitionerCreation,
            facilityId: facilityId,
            modalityPractitioner: modalityPractitionerName,
            showInlineAlert: showInlineAlert,
            onUpdateStudyReferringPractitioner: handleUpdateNewlyPractitionerCreated
          })
        }))
      });
    });
  });

  const generateDefaultValues = text => {
    if (text.includes('@')) return {
      email: text
    };
    if (/^\d{10}$/.test(text)) return {
      phone: {
        phone: text
      }
    };
    return {
      name: text
    };
  };

  return {
    modalNode,
    handleCreatePractitioner
  };
};

const DEFAULT_LIST_OFFSET = 0;
const MAX_AMOUNT_ITEMS_TO_RETRIEVE = 30;
const toWhomItMayConcernId = 'AQC';
const formatPractitionerRowData = ({
  practitionerEmail,
  practitionerPhone,
  practitionerFullName,
  practitionerHasAccess,
  practitionerStatus,
  isSelected,
  practitionerId,
  withoutInfoText,
  telText,
  locale
}) => {
  const practitionerOption = {
    hasAccess: practitionerHasAccess || false,
    name: practitionerFullName || '',
    status: practitionerStatus
  };

  const formatItemSubText = () => {
    if (!practitionerPhone && !practitionerEmail) return jsx("p", Object.assign({
      className: "e-text-neutral-400 e-text-xs"
    }, {
      children: withoutInfoText
    }));
    if (practitionerPhone && practitionerEmail) return jsxs("p", Object.assign({
      className: "e-text-neutral-300 e-text-xs"
    }, {
      children: [telText, " ", practitionerPhone, " \u2022 ", practitionerEmail]
    }));
    if (!practitionerPhone) return jsx("p", Object.assign({
      className: "e-text-neutral-300 e-text-xs"
    }, {
      children: practitionerEmail
    }));
    return jsx("p", Object.assign({
      className: "e-text-neutral-300 e-text-xs"
    }, {
      children: practitionerPhone
    }));
  };

  return {
    isSelected,
    itemId: practitionerId || '',
    subItem: formatItemSubText(),
    item: jsx(ProductTag, {
      locale: locale,
      option: practitionerOption
    })
  };
};
/**
 * Search modal implementation for showing a list of practitioners
 * that can be assigned to an study and also shows a footer button
 * for creating and assigning new practitioners.
 * @author Salvador Gonzalez<salvador.gonzalez@evacenter.com>
 * Created 2023-11-21
 */

const ReferringPractitionerSearchModal = ({
  onClose,
  studyId,
  referringPractitionerId,
  modalityPractitionerName,
  locale,
  defaultPractitioner,
  hasEditPermissions,
  onSuccessPractitionerCreation,
  onSuccessUpdate,
  onErrorUpdate,
  facilityId
}) => {
  const [searchText, setSearchText] = useState('');
  const [hideSearchModal, setHideSearchModal] = useState(false);
  const classes = {
    searchModal: cn('e-flex', {
      'e-hidden': hideSearchModal
    })
  };
  const {
    modalNode,
    openModal
  } = useModal();
  const [offset, setOffset] = useState(DEFAULT_LIST_OFFSET);
  const [practitionersList, setPractitionersList] = useState([]);
  const {
    translations,
    getTranslations
  } = usePractitionerTranslations(locale);
  const createdPhysicianName = useRef();
  const [hastNextPage, setHasNextPage] = useState(true);
  const [rows, setRows] = useState([]);
  const isAQCItem = Boolean(!modalityPractitionerName) && !referringPractitionerId;
  const {
    handleCreatePractitioner,
    modalNode: createPractitionerModalNode
  } = useSearchModalFooter({
    studyId: studyId || '',
    facilityId,
    locale,
    onSuccessUpdate,
    onErrorUpdate,
    modalityPractitionerName: modalityPractitionerName || '',
    onOpenFooterModal: () => {
      setHideSearchModal(true);
    },
    onCloseFooterModal: () => {
      setHideSearchModal(false);
    },
    onClose,
    hasEditPermissions: hasEditPermissions || false,
    showInlineAlert: false,
    onSuccessPractitionerCreation
  });

  const clearCurrentPractitionersState = () => {
    setPractitionersList([]);
    setRows([]);

    if (hasError) {
      setPractitionersList(() => [...practitionersList]);
      setRows(() => [...rows]);
    }

    setOffset(DEFAULT_LIST_OFFSET);
  };

  const {
    referringPractitioners,
    totalCount,
    loading,
    getReferringPractitioners,
    hasError,
    resetState,
    isFirstLoading
  } = useGetReferringPractitioners({
    searchText,
    limit: MAX_AMOUNT_ITEMS_TO_RETRIEVE,
    onFetch: clearCurrentPractitionersState,
    offset
  });
  const {
    updateStudyReferringPractitioner
  } = useUpdateStudyReferringPractitioner({
    onSuccess: () => {
      var _a, _b;

      if (onSuccessUpdate) onSuccessUpdate(((_a = createdPhysicianName === null || createdPhysicianName === void 0 ? void 0 : createdPhysicianName.current) === null || _a === void 0 ? void 0 : _a.id) || '', ((_b = createdPhysicianName === null || createdPhysicianName === void 0 ? void 0 : createdPhysicianName.current) === null || _b === void 0 ? void 0 : _b.name) || '');
      if (onClose) onClose(); // clean string

      createdPhysicianName.current = {
        name: '',
        id: ''
      };
    },
    onError: () => {
      if (onErrorUpdate) onErrorUpdate();
    }
  });
  useEffect(() => {
    getTranslations(searchText); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);
  useEffect(() => {
    getReferringPractitioners(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = (itemId, toWhomItMayConcern) => {
    const input = toWhomItMayConcern ? {
      referringPractitioner: null,
      dicomReferringPhysician: null,
      dicomRequestingPhysician: null
    } : {
      referringPractitioner: itemId
    };
    return updateStudyReferringPractitioner({
      variables: {
        id: studyId,
        input
      }
    });
  };

  useEffect(() => {
    setPractitionersList(previousPractitioners => {
      const tmpPractitioners = [...previousPractitioners, ...referringPractitioners];
      const uniqueArray = Array.from(new Map(tmpPractitioners.map(item => [item.id, item])).values());
      return uniqueArray;
    }); // Map the other practitioners to row data

    const rowDataList = referringPractitioners.reduce((accumulator, practitioner) => {
      if (practitioner.id !== (defaultPractitioner === null || defaultPractitioner === void 0 ? void 0 : defaultPractitioner.itemId)) {
        accumulator.push(formatPractitionerRowData({
          practitionerEmail: practitioner.email,
          practitionerPhone: practitioner.phone.phone,
          practitionerFullName: practitioner.fullName,
          practitionerHasAccess: practitioner.hasAccess,
          practitionerId: practitioner.id,
          practitionerStatus: practitioner.status,
          isSelected: false,
          withoutInfoText: translations.withoutContactInformation,
          telText: translations.tel,
          locale
        }));
      }

      return accumulator;
    }, []); // If a selected practitioner was found, prepend it to the list

    if (defaultPractitioner) {
      rowDataList.unshift(defaultPractitioner);
    }

    setRows(previousPractitioners => {
      const practitioners = [...previousPractitioners, ...rowDataList];
      const tmpPractitioners = searchText === '' ? [{
        isSelected: isAQCItem,
        item: translations.toWhomItMayConcern,
        itemId: toWhomItMayConcernId,
        subItem: jsx("p", Object.assign({
          className: "e-text-neutral-300 e-text-xs"
        }, {
          children: translations.toWhomItMayConcernDisclaimer
        }))
      }, ...practitioners] : practitioners;
      const uniqueArray = Array.from(new Map(tmpPractitioners.map(item => [item.itemId, item])).values());
      return uniqueArray;
    });
    setHasNextPage(getHasNextPage(totalCount || 0, practitionersList.length)); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [referringPractitioners, referringPractitionerId]);

  const handleConfirm = (itemId, toWhomItMayConcern) => {
    if (handleSubmit) handleSubmit(itemId, toWhomItMayConcern);
  };

  const handleItemClick = itemId => __awaiter(void 0, void 0, void 0, function* () {
    const toWhomItMayConcern = itemId === toWhomItMayConcernId;
    const selectedItem = practitionersList.find(practitioner => practitioner.id === itemId);
    createdPhysicianName.current = {
      name: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.fullName) || '',
      id: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) || ''
    };
    if (toWhomItMayConcern) createdPhysicianName.current = {
      name: '',
      id: toWhomItMayConcernId
    };

    const formatSelected = () => {
      return rows.map(row => {
        const isSelected = (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) === row.itemId || (row === null || row === void 0 ? void 0 : row.itemId) === toWhomItMayConcernId && toWhomItMayConcern;
        return {
          isSelected,
          itemId: row.itemId,
          item: row.item,
          subItem: row.subItem
        };
      });
    };

    setRows(formatSelected());
    const modalTitle = toWhomItMayConcern ? translations.confirmConcernModalTitle : translations.confirmPractitioner;
    yield openModal(close => {
      setHideSearchModal(true);
      return jsx(BaseModal, {
        size: ModalSize.lg,
        onClose: () => {
          setHideSearchModal(false);
          close();
        },
        body: jsx(AssignationModal, {
          locale: locale,
          toWhomItMayConcern: toWhomItMayConcern,
          practitioner: selectedItem
        }),
        header: {
          title: modalTitle,
          hasCloseBtn: true
        },
        footer: jsxs("div", Object.assign({
          className: "e-w-full e-flex e-justify-between"
        }, {
          children: [jsx(Button, Object.assign({
            onClick: () => {
              setHideSearchModal(false);
              close();
            },
            startIcon: IconCatalog.arrowLeft,
            size: ButtonSize.sm,
            variant: ButtonVariant.tertiary
          }, {
            children: translations.goBack
          })), jsx(Button, Object.assign({
            onClick: () => {
              handleConfirm(itemId, toWhomItMayConcern); // closes current modal

              setHideSearchModal(false);
              close(); //closes parent modal

              if (onClose) onClose();
            },
            size: ButtonSize.sm,
            variant: ButtonVariant.primary
          }, {
            children: translations.confirm
          }))]
        }))
      });
    });
  });

  const handleSearchChange = value => {
    setSearchText(value);
  };

  const clearSearch = () => {
    clearCurrentPractitionersState();
    setSearchText('');
  };

  const formatAlertMsg = () => {
    return jsxs("div", Object.assign({
      className: "e-flex"
    }, {
      children: [jsx("span", Object.assign({
        className: "e-text-neutral-300"
      }, {
        children: translations.modalityPractitionerDescription
      })), jsx("p", Object.assign({
        className: "e-text-base-white e-ml-1"
      }, {
        children: modalityPractitionerName
      }))]
    }));
  };

  const handleErrorstate = () => {
    resetState();
    getReferringPractitioners();
  };

  const handleSearchModalFooterClick = () => {
    handleCreatePractitioner('');
  };

  return jsxs(Fragment, {
    children: [jsx(CustomSearchModal, {
      className: classes.searchModal,
      alertMsg: formatAlertMsg(),
      modalTitle: translations.modalTitle,
      searchBarPlaceholder: translations.searchBarPlaceholder,
      emptyStateProps: {
        emptyStateTitle: translations.emtpyStateTitle,
        emptyStateDescription: translations.emptyStateDescription,
        emptyStateButtonText: translations.emptyStateButtonText,
        emptyStateButtonClick: () => handleCreatePractitioner(searchText)
      },
      errorStateProps: {
        errorStateTitle: translations.errorStateTitle,
        errorStateBody: translations.errorStateBody,
        errorStateButtonText: translations.errorStateButtonText,
        errorStateButtonClick: handleErrorstate
      },
      searchEmptyStateProps: {
        title: translations.searchEmptyStateTitle,
        description: translations.searchEmptyStateDescription,
        buttonText: translations.searchEmptyStateButtonText,
        searchStateButtonClick: () => handleCreatePractitioner(searchText)
      },
      hasError: hasError,
      searchText: searchText,
      onCleanClick: clearSearch,
      hasMoreResults: hastNextPage,
      showSkeletons: isFirstLoading,
      showAlertMsg: Boolean(modalityPractitionerName) && !referringPractitionerId,
      isFetchingMore: loading,
      rowsData: rows,
      onItemClick: handleItemClick,
      onLoadMore: () => setOffset(practitionersList.length),
      onSearchChange: handleSearchChange,
      onClose: onClose,
      footer: jsx(SearchModalFooter, {
        onClick: handleSearchModalFooterClick,
        locale: locale
      })
    }), modalNode, createPractitionerModalNode]
  });
};

const usePractitionerSearchModal = _a => {
  var {
    client,
    onCloseModal
  } = _a,
      restOfProps = __rest(_a, ["client", "onCloseModal"]);

  const {
    modalNode,
    openModal
  } = useModal();

  const handleOpenSearchModal = () => __awaiter(void 0, void 0, void 0, function* () {
    yield openModal(close => {
      const handleOnCloseModal = () => {
        if (onCloseModal) onCloseModal();
        close();
      };

      return jsx(ApolloProvider, Object.assign({
        client: client
      }, {
        children: jsx(ReferringPractitionerSearchModal, Object.assign({}, restOfProps, {
          onClose: handleOnCloseModal
        }))
      }));
    });
  });

  return {
    modalNode,
    handleOpenSearchModal
  };
};

export { AssignationModal, CUSTOM_EMAIL_VALIDATION, CUSTOM_PASSWORD_VALIDATION_LETTERS_AND_NUMBERS, CUSTOM_PASSWORD_VALIDATION_UPPER_AND_LOWER_CASE, CreatePractitionerModal, CustomSearchModal, DEFAULT_LIST_OFFSET, FieldTypes, MAX_AMOUNT_ITEMS_TO_RETRIEVE, PractitionerStatus, ProductTag, ReferringPractitionerSearchModal, cleanInputData, formatPractitionerRowData, formatSelectOption, getDateField, getDynamicSchema, getEmailField, getFieldControl, getHasNextPage, getLazyField, getPhoneField, getPhoneNumberString, getPhoneObjectField, getPhoneObjectOptionalField, getPhoneOptionalField, getTextField, getTextFromMaybeType, getValueFromSelectOption, studyFormSchema, toWhomItMayConcernId, usePractitionerSearchModal, validateEmail, validatePasswordLettersAndNumbers, validatePasswordUpperAndLowerCase, validatePhone };
